/* eslint-disable @typescript-eslint/naming-convention */
export const languageDataLocalizationMap: { [key: string]: string } = {
    'en-US.aa': 'Afar',
    'en-US.ab': 'Abkhaz',
    'en-US.ae': 'Avestan',
    'en-US.af': 'Afrikaans',
    'en-US.ak': 'Akan',
    'en-US.am': 'Amharic',
    'en-US.an': 'Aragonese',
    'en-US.ar': 'Arabic',
    'en-US.as': 'Assamese',
    'en-US.av': 'Avaric',
    'en-US.ay': 'Aymara',
    'en-US.az': 'South Azerbaijani',
    'en-US.ba': 'Bashkir',
    'en-US.be': 'Belarusian',
    'en-US.bg': 'Bulgarian',
    'en-US.bh': 'Bihari',
    'en-US.bi': 'Bislama',
    'en-US.bm': 'Bambara',
    'en-US.bn': 'Bengali',
    'en-US.bo': 'Tibetan Standard',
    'en-US.br': 'Breton',
    'en-US.bs': 'Bosnian',
    'en-US.ca': 'Catalan',
    'en-US.ce': 'Chechen',
    'en-US.ch': 'Chamorro',
    'en-US.co': 'Corsican',
    'en-US.cr': 'Cree',
    'en-US.cs': 'Czech',
    'en-US.cu': 'Old Church Slavonic',
    'en-US.cv': 'Chuvash',
    'en-US.cy': 'Welsh',
    'en-US.da': 'Danish',
    'en-US.de': 'German',
    'en-US.dv': 'Divehi',
    'en-US.dz': 'Dzongkha',
    'en-US.ee': 'Ewe',
    'en-US.el': 'Greek, Modern',
    'en-US.en': 'English',
    'en-US.eo': 'Esperanto',
    'en-US.es': 'Spanish',
    'en-US.et': 'Estonian',
    'en-US.eu': 'Basque',
    'en-US.fa': 'Persian',
    'en-US.ff': 'Fula',
    'en-US.fi': 'Finnish',
    'en-US.fj': 'Fijian',
    'en-US.fo': 'Faroese',
    'en-US.fr': 'French',
    'en-US.fy': 'Western Frisian',
    'en-US.ga': 'Irish',
    'en-US.gd': 'Scottish Gaelic',
    'en-US.gl': 'Galician',
    'en-US.gn': 'Guarani',
    'en-US.gu': 'Gujarati',
    'en-US.gv': 'Manx',
    'en-US.ha': 'Hausa',
    'en-US.he': 'Hebrew',
    'en-US.iw': 'Hebrew',
    'en-US.hi': 'Hindi',
    'en-US.ho': 'Hiri Motu',
    'en-US.hr': 'Croatian',
    'en-US.ht': 'Haitian',
    'en-US.hu': 'Hungarian',
    'en-US.hy': 'Armenian',
    'en-US.hz': 'Herero',
    'en-US.ia': 'Interlingua',
    'en-US.in': 'Indonesian',
    'en-US.ie': 'Interlingue',
    'en-US.ig': 'Igbo',
    'en-US.ii': 'Nuosu',
    'en-US.ik': 'Inupiaq',
    'en-US.io': 'Ido',
    'en-US.is': 'Icelandic',
    'en-US.it': 'Italian',
    'en-US.iu': 'Inuktitut',
    'en-US.ja': 'Japanese',
    'en-US.jv': 'Javanese',
    'en-US.ka': 'Georgian',
    'en-US.kg': 'Kongo',
    'en-US.ki': 'Kikuyu',
    'en-US.kj': 'Kwanyama',
    'en-US.kk': 'Kazakh',
    'en-US.kl': 'Kalaallisut',
    'en-US.km': 'Khmer',
    'en-US.kn': 'Kannada',
    'en-US.ko': 'Korean',
    'en-US.kr': 'Kanuri',
    'en-US.ks': 'Kashmiri',
    'en-US.ku': 'Kurdish',
    'en-US.kv': 'Komi',
    'en-US.kw': 'Cornish',
    'en-US.ky': 'Kyrgyz',
    'en-US.la': 'Latin',
    'en-US.lb': 'Luxembourgish',
    'en-US.lg': 'Ganda',
    'en-US.li': 'Limburgish',
    'en-US.ln': 'Lingala',
    'en-US.lo': 'Lao',
    'en-US.lt': 'Lithuanian',
    'en-US.lu': 'Luba-Katanga',
    'en-US.lv': 'Latvian',
    'en-US.mg': 'Malagasy',
    'en-US.mh': 'Marshallese',
    'en-US.mi': 'Maori',
    'en-US.mk': 'Macedonian',
    'en-US.ml': 'Malayalam',
    'en-US.mn': 'Mongolian',
    'en-US.mr': 'Marathi',
    'en-US.ms': 'Malay',
    'en-US.mt': 'Maltese',
    'en-US.my': 'Burmese',
    'en-US.na': 'Nauru',
    'en-US.nb': 'Norwegian Bokmål',
    'en-US.nd': 'North Ndebele',
    'en-US.ne': 'Nepali',
    'en-US.ng': 'Ndonga',
    'en-US.nl': 'Dutch',
    'en-US.nn': 'Norwegian Nynorsk',
    'en-US.no': 'Norwegian',
    'en-US.nr': 'South Ndebele',
    'en-US.nv': 'Navajo, Navaho',
    'en-US.ny': 'Chichewa',
    'en-US.oc': 'Occitan',
    'en-US.oj': 'Ojibwe, Ojibwa',
    'en-US.om': 'Oromo',
    'en-US.or': 'Oriya',
    'en-US.os': 'Ossetian, Ossetic',
    'en-US.pa': 'Panjabi, Punjabi',
    'en-US.pi': 'Pali',
    'en-US.pl': 'Polish',
    'en-US.ps': 'Pashto, Pushto',
    'en-US.pt': 'Portuguese',
    'en-US.qu': 'Quechua',
    'en-US.rm': 'Romansh',
    'en-US.rn': 'Kirundi',
    'en-US.ro': 'Romanian',
    'en-US.ru': 'Russian',
    'en-US.rw': 'Kinyarwanda',
    'en-US.sa': 'Sanskrit',
    'en-US.sc': 'Sardinian',
    'en-US.sd': 'Sindhi',
    'en-US.se': 'Northern Sami',
    'en-US.sg': 'Sango',
    'en-US.si': 'Sinhala',
    'en-US.sk': 'Slovak',
    'en-US.sl': 'Slovene',
    'en-US.sm': 'Samoan',
    'en-US.sn': 'Shona',
    'en-US.so': 'Somali',
    'en-US.sq': 'Albanian',
    'en-US.sr': 'Serbian',
    'en-US.ss': 'Swati',
    'en-US.st': 'Southern Sotho',
    'en-US.su': 'Sundanese',
    'en-US.sv': 'Swedish',
    'en-US.sw': 'Swahili',
    'en-US.ta': 'Tamil',
    'en-US.te': 'Telugu',
    'en-US.tg': 'Tajik',
    'en-US.th': 'Thai',
    'en-US.ti': 'Tigrinya',
    'en-US.tk': 'Turkmen',
    'en-US.tl': 'Tagalog',
    'en-US.tn': 'Tswana',
    'en-US.to': 'Tonga',
    'en-US.tr': 'Turkish',
    'en-US.ts': 'Tsonga',
    'en-US.tt': 'Tatar',
    'en-US.tw': 'Twi',
    'en-US.ty': 'Tahitian',
    'en-US.ug': 'Uyghur',
    'en-US.uk': 'Ukrainian',
    'en-US.ur': 'Urdu',
    'en-US.uz': 'Uzbek',
    'en-US.ve': 'Venda',
    'en-US.vi': 'Vietnamese',
    'en-US.vo': 'Volapük',
    'en-US.wa': 'Walloon',
    'en-US.wo': 'Wolof',
    'en-US.xh': 'Xhosa',
    'en-US.yi': 'Yiddish',
    'en-US.yo': 'Yoruba',
    'en-US.za': 'Zhuang',
    'en-US.zh': 'Chinese',
    'en-US.zu': 'Zulu',
    'en-US.en-US': 'English (US)',
    'en-US.en-GB': 'English (UK)',
    'en-US.fr-FR': 'French',
    'en-US.fr-CA': 'French (Canadian)',
    // en-GB
    'en-GB.aa': 'Afar',
    'en-GB.ab': 'Abkhaz',
    'en-GB.ae': 'Avestan',
    'en-GB.af': 'Afrikaans',
    'en-GB.ak': 'Akan',
    'en-GB.am': 'Amharic',
    'en-GB.an': 'Aragonese',
    'en-GB.ar': 'Arabic',
    'en-GB.as': 'Assamese',
    'en-GB.av': 'Avaric',
    'en-GB.ay': 'Aymara',
    'en-GB.az': 'South Azerbaijani',
    'en-GB.ba': 'Bashkir',
    'en-GB.be': 'Belarusian',
    'en-GB.bg': 'Bulgarian',
    'en-GB.bh': 'Bihari',
    'en-GB.bi': 'Bislama',
    'en-GB.bm': 'Bambara',
    'en-GB.bn': 'Bengali',
    'en-GB.bo': 'Tibetan Standard',
    'en-GB.br': 'Breton',
    'en-GB.bs': 'Bosnian',
    'en-GB.ca': 'Catalan',
    'en-GB.ce': 'Chechen',
    'en-GB.ch': 'Chamorro',
    'en-GB.co': 'Corsican',
    'en-GB.cr': 'Cree',
    'en-GB.cs': 'Czech',
    'en-GB.cu': 'Old Church Slavonic',
    'en-GB.cv': 'Chuvash',
    'en-GB.cy': 'Welsh',
    'en-GB.da': 'Danish',
    'en-GB.de': 'German',
    'en-GB.dv': 'Divehi',
    'en-GB.dz': 'Dzongkha',
    'en-GB.ee': 'Ewe',
    'en-GB.el': 'Greek, Modern',
    'en-GB.en': 'English',
    'en-GB.eo': 'Esperanto',
    'en-GB.es': 'Spanish',
    'en-GB.et': 'Estonian',
    'en-GB.eu': 'Basque',
    'en-GB.fa': 'Persian',
    'en-GB.ff': 'Fula',
    'en-GB.fi': 'Finnish',
    'en-GB.fj': 'Fijian',
    'en-GB.fo': 'Faroese',
    'en-GB.fr': 'French',
    'en-GB.fy': 'Western Frisian',
    'en-GB.ga': 'Irish',
    'en-GB.gd': 'Scottish Gaelic',
    'en-GB.gl': 'Galician',
    'en-GB.gn': 'Guarani',
    'en-GB.gu': 'Gujarati',
    'en-GB.gv': 'Manx',
    'en-GB.ha': 'Hausa',
    'en-GB.he': 'Hebrew',
    'en-GB.iw': 'Hebrew',
    'en-GB.hi': 'Hindi',
    'en-GB.ho': 'Hiri Motu',
    'en-GB.hr': 'Croatian',
    'en-GB.ht': 'Haitian',
    'en-GB.hu': 'Hungarian',
    'en-GB.hy': 'Armenian',
    'en-GB.hz': 'Herero',
    'en-GB.ia': 'Interlingua',
    'en-GB.in': 'Indonesian',
    'en-GB.ie': 'Interlingue',
    'en-GB.ig': 'Igbo',
    'en-GB.ii': 'Nuosu',
    'en-GB.ik': 'Inupiaq',
    'en-GB.io': 'Ido',
    'en-GB.is': 'Icelandic',
    'en-GB.it': 'Italian',
    'en-GB.iu': 'Inuktitut',
    'en-GB.ja': 'Japanese',
    'en-GB.jv': 'Javanese',
    'en-GB.ka': 'Georgian',
    'en-GB.kg': 'Kongo',
    'en-GB.ki': 'Kikuyu',
    'en-GB.kj': 'Kwanyama',
    'en-GB.kk': 'Kazakh',
    'en-GB.kl': 'Kalaallisut',
    'en-GB.km': 'Khmer',
    'en-GB.kn': 'Kannada',
    'en-GB.ko': 'Korean',
    'en-GB.kr': 'Kanuri',
    'en-GB.ks': 'Kashmiri',
    'en-GB.ku': 'Kurdish',
    'en-GB.kv': 'Komi',
    'en-GB.kw': 'Cornish',
    'en-GB.ky': 'Kyrgyz',
    'en-GB.la': 'Latin',
    'en-GB.lb': 'Luxembourgish',
    'en-GB.lg': 'Ganda',
    'en-GB.li': 'Limburgish',
    'en-GB.ln': 'Lingala',
    'en-GB.lo': 'Lao',
    'en-GB.lt': 'Lithuanian',
    'en-GB.lu': 'Luba-Katanga',
    'en-GB.lv': 'Latvian',
    'en-GB.mg': 'Malagasy',
    'en-GB.mh': 'Marshallese',
    'en-GB.mi': 'Maori',
    'en-GB.mk': 'Macedonian',
    'en-GB.ml': 'Malayalam',
    'en-GB.mn': 'Mongolian',
    'en-GB.mr': 'Marathi',
    'en-GB.ms': 'Malay',
    'en-GB.mt': 'Maltese',
    'en-GB.my': 'Burmese',
    'en-GB.na': 'Nauru',
    'en-GB.nb': 'Norwegian Bokmål',
    'en-GB.nd': 'North Ndebele',
    'en-GB.ne': 'Nepali',
    'en-GB.ng': 'Ndonga',
    'en-GB.nl': 'Dutch',
    'en-GB.nn': 'Norwegian Nynorsk',
    'en-GB.no': 'Norwegian',
    'en-GB.nr': 'South Ndebele',
    'en-GB.nv': 'Navajo, Navaho',
    'en-GB.ny': 'Chichewa',
    'en-GB.oc': 'Occitan',
    'en-GB.oj': 'Ojibwe, Ojibwa',
    'en-GB.om': 'Oromo',
    'en-GB.or': 'Oriya',
    'en-GB.os': 'Ossetian, Ossetic',
    'en-GB.pa': 'Panjabi, Punjabi',
    'en-GB.pi': 'Pali',
    'en-GB.pl': 'Polish',
    'en-GB.ps': 'Pashto, Pushto',
    'en-GB.pt': 'Portuguese',
    'en-GB.qu': 'Quechua',
    'en-GB.rm': 'Romansh',
    'en-GB.rn': 'Kirundi',
    'en-GB.ro': 'Romanian',
    'en-GB.ru': 'Russian',
    'en-GB.rw': 'Kinyarwanda',
    'en-GB.sa': 'Sanskrit',
    'en-GB.sc': 'Sardinian',
    'en-GB.sd': 'Sindhi',
    'en-GB.se': 'Northern Sami',
    'en-GB.sg': 'Sango',
    'en-GB.si': 'Sinhala',
    'en-GB.sk': 'Slovak',
    'en-GB.sl': 'Slovene',
    'en-GB.sm': 'Samoan',
    'en-GB.sn': 'Shona',
    'en-GB.so': 'Somali',
    'en-GB.sq': 'Albanian',
    'en-GB.sr': 'Serbian',
    'en-GB.ss': 'Swati',
    'en-GB.st': 'Southern Sotho',
    'en-GB.su': 'Sundanese',
    'en-GB.sv': 'Swedish',
    'en-GB.sw': 'Swahili',
    'en-GB.ta': 'Tamil',
    'en-GB.te': 'Telugu',
    'en-GB.tg': 'Tajik',
    'en-GB.th': 'Thai',
    'en-GB.ti': 'Tigrinya',
    'en-GB.tk': 'Turkmen',
    'en-GB.tl': 'Tagalog',
    'en-GB.tn': 'Tswana',
    'en-GB.to': 'Tonga',
    'en-GB.tr': 'Turkish',
    'en-GB.ts': 'Tsonga',
    'en-GB.tt': 'Tatar',
    'en-GB.tw': 'Twi',
    'en-GB.ty': 'Tahitian',
    'en-GB.ug': 'Uyghur',
    'en-GB.uk': 'Ukrainian',
    'en-GB.ur': 'Urdu',
    'en-GB.uz': 'Uzbek',
    'en-GB.ve': 'Venda',
    'en-GB.vi': 'Vietnamese',
    'en-GB.vo': 'Volapük',
    'en-GB.wa': 'Walloon',
    'en-GB.wo': 'Wolof',
    'en-GB.xh': 'Xhosa',
    'en-GB.yi': 'Yiddish',
    'en-GB.yo': 'Yoruba',
    'en-GB.za': 'Zhuang',
    'en-GB.zh': 'Chinese',
    'en-GB.zu': 'Zulu',
    'en-GB.en-US': 'English (US)',
    'en-GB.en-GB': 'English (UK)',
    'en-GB.fr-FR': 'French',
    'en-GB.fr-CA': 'French (Canadian)',
    // fr-CA: French Canadian
    'fr-CA.aa': 'Afare',
    'fr-CA.ab': 'Abkhaze',
    'fr-CA.ae': 'Avestan',
    'fr-CA.af': 'Afrikaans',
    'fr-CA.ak': 'Akan',
    'fr-CA.am': 'Amharique',
    'fr-CA.an': 'Aragonais',
    'fr-CA.ar': 'Arabe',
    'fr-CA.as': 'Assamais',
    'fr-CA.av': 'Avarique',
    'fr-CA.ay': 'Aymara',
    'fr-CA.az': 'Azerbaïdjanais du sud',
    'fr-CA.ba': 'Bachkir',
    'fr-CA.be': 'Biélorusse',
    'fr-CA.bg': 'Bulgare',
    'fr-CA.bh': 'Bihari',
    'fr-CA.bi': 'Bislama',
    'fr-CA.bm': 'Bambara',
    'fr-CA.bn': 'Bengali',
    'fr-CA.bo': 'Norme tibétaine',
    'fr-CA.br': 'Breton',
    'fr-CA.bs': 'Bosniaque',
    'fr-CA.ca': 'Catalan',
    'fr-CA.ce': 'Tchétchène',
    'fr-CA.ch': 'Chamorro',
    'fr-CA.co': 'Corse',
    'fr-CA.cr': 'Cri',
    'fr-CA.cs': 'Tchèque',
    'fr-CA.cu': 'Slave d\'église ancienne',
    'fr-CA.cv': 'Tchouvache',
    'fr-CA.cy': 'Gallois',
    'fr-CA.da': 'Danois',
    'fr-CA.de': 'Allemand',
    'fr-CA.dv': 'Divehi',
    'fr-CA.dz': 'Dzongkha',
    'fr-CA.ee': 'Brebis',
    'fr-CA.el': 'Grec, Moderne',
    'fr-CA.en': 'Anglais',
    'fr-CA.eo': 'Espéranto',
    'fr-CA.es': 'Espanol',
    'fr-CA.et': 'Estonien',
    'fr-CA.eu': 'Basque',
    'fr-CA.fa': 'Persan',
    'fr-CA.ff': 'Peul',
    'fr-CA.fi': 'Finlandais',
    'fr-CA.fj': 'Fidjien',
    'fr-CA.fo': 'Féroïen',
    'fr-CA.fr': 'Français',
    'fr-CA.fy': 'Frison occidental',
    'fr-CA.ga': 'Irlandais',
    'fr-CA.gd': 'Gaélique écossais',
    'fr-CA.gl': 'Galicien',
    'fr-CA.gn': 'Guarani',
    'fr-CA.gu': 'Gujarati',
    'fr-CA.gv': 'Mannois',
    'fr-CA.ha': 'Haoussa',
    'fr-CA.he': 'Hébreu',
    'fr-CA.iw': 'Hébreu',
    'fr-CA.hi': 'Hindi',
    'fr-CA.ho': 'Hiri Motu',
    'fr-CA.hr': 'Croate',
    'fr-CA.ht': 'Haïtien',
    'fr-CA.hu': 'Hongrois',
    'fr-CA.hy': 'Arménien',
    'fr-CA.hz': 'Héréro',
    'fr-CA.ia': 'Interlingue',
    'fr-CA.in': 'Indonésien',
    'fr-CA.ie': 'Interlingue',
    'fr-CA.ig': 'Ibo',
    'fr-CA.ii': 'Nuosu',
    'fr-CA.ik': 'Inupiaq',
    'fr-CA.io': 'Je fais',
    'fr-CA.is': 'Islandais',
    'fr-CA.it': 'Italien',
    'fr-CA.iu': 'Inuktitut',
    'fr-CA.ja': 'Japonais',
    'fr-CA.jv': 'Javanais',
    'fr-CA.ka': 'Géorgien',
    'fr-CA.kg': 'Kongo',
    'fr-CA.ki': 'Kikuyu',
    'fr-CA.kj': 'Kwanyama',
    'fr-CA.kk': 'Kazakh',
    'fr-CA.kl': 'Kalaallisout',
    'fr-CA.km': 'Khmer',
    'fr-CA.kn': 'Kannada',
    'fr-CA.ko': 'Coréen',
    'fr-CA.kr': 'Kanuri',
    'fr-CA.ks': 'Cachemire',
    'fr-CA.ku': 'Kurde',
    'fr-CA.kv': 'Komis',
    'fr-CA.kw': 'Cornouaillais',
    'fr-CA.ky': 'Kirghize',
    'fr-CA.la': 'Latin',
    'fr-CA.lb': 'Luxembourgeois',
    'fr-CA.lg': 'Ganda',
    'fr-CA.li': 'Limbourgeois',
    'fr-CA.ln': 'Lingala',
    'fr-CA.lo': 'Lao',
    'fr-CA.lt': 'Lituanien',
    'fr-CA.lu': 'Luba-Katanga',
    'fr-CA.lv': 'Letton',
    'fr-CA.mg': 'Malgache',
    'fr-CA.mh': 'Marshallais',
    'fr-CA.mi': 'Maori',
    'fr-CA.mk': 'Macédonien',
    'fr-CA.ml': 'Malayalam',
    'fr-CA.mn': 'Mongol',
    'fr-CA.mr': 'Marathi',
    'fr-CA.ms': 'Malais',
    'fr-CA.mt': 'Maltais',
    'fr-CA.my': 'Birman',
    'fr-CA.na': 'Nauru',
    'fr-CA.nb': 'Norvégien bokml',
    'fr-CA.nd': 'Nord Ndebele',
    'fr-CA.ne': 'Népalais',
    'fr-CA.ng': 'Ndonga',
    'fr-CA.nl': 'Néerlandais',
    'fr-CA.nn': 'Nynorsk norvégien',
    'fr-CA.no': 'Norvégien',
    'fr-CA.nr': 'Sud Ndebele',
    'fr-CA.nv': 'Navajo, Navaho',
    'fr-CA.ny': 'Chichewa',
    'fr-CA.oc': 'Occitan',
    'fr-CA.oj': 'Ojibwé, Ojibwé',
    'fr-CA.om': 'Galla',
    'fr-CA.or': 'Oriya',
    'fr-CA.os': 'Ossète, Ossétique',
    'fr-CA.pa': 'Panjabi, Pendjabi',
    'fr-CA.pi': 'Pali',
    'fr-CA.pl': 'Polonais',
    'fr-CA.ps': 'Pashto, Pushto',
    'fr-CA.pt': 'Portugais',
    'fr-CA.qu': 'Quechua',
    'fr-CA.rm': 'Romanche',
    'fr-CA.rn': 'Kirundi',
    'fr-CA.ro': 'Roumain',
    'fr-CA.ru': 'Russe',
    'fr-CA.rw': 'Kinyarwanda',
    'fr-CA.sa': 'Sanskrit',
    'fr-CA.sc': 'Sarde',
    'fr-CA.sd': 'Sindhi',
    'fr-CA.se': 'Sâme du Nord',
    'fr-CA.sg': 'Sango',
    'fr-CA.si': 'Cinghalais',
    'fr-CA.sk': 'Slovaque',
    'fr-CA.sl': 'Slovène',
    'fr-CA.sm': 'Samoa',
    'fr-CA.sn': 'Shona',
    'fr-CA.so': 'Somali',
    'fr-CA.sq': 'Albanais',
    'fr-CA.sr': 'Serbe',
    'fr-CA.ss': 'Swati',
    'fr-CA.st': 'Sotho du Sud',
    'fr-CA.su': 'Sundanais',
    'fr-CA.sv': 'Suédois',
    'fr-CA.sw': 'Twahili',
    'fr-CA.ta': 'Tamil',
    'fr-CA.te': 'Telugu',
    'fr-CA.tg': 'Tadjik',
    'fr-CA.th': 'Thaïlandais',
    'fr-CA.ti': 'Tigrinya',
    'fr-CA.tk': 'Turkmène',
    'fr-CA.tl': 'Tagalog',
    'fr-CA.tn': 'Tswana',
    'fr-CA.to': 'Tonga',
    'fr-CA.tr': 'Turc',
    'fr-CA.ts': 'Tsonga',
    'fr-CA.tt': 'Tatar',
    'fr-CA.tw': 'Twi',
    'fr-CA.ty': 'Tahitien',
    'fr-CA.ug': 'Ouïghour',
    'fr-CA.uk': 'Ukrainien',
    'fr-CA.ur': 'Ourdou',
    'fr-CA.uz': 'Ouzbek',
    'fr-CA.ve': 'Venda',
    'fr-CA.vi': 'Vietnamien',
    'fr-CA.vo': 'Volapík',
    'fr-CA.wa': 'Wallon',
    'fr-CA.wo': 'Wolof',
    'fr-CA.xh': 'Xhosa',
    'fr-CA.yi': 'Yiddish',
    'fr-CA.yo': 'Yoruba',
    'fr-CA.za': 'Zhuang',
    'fr-CA.zh': 'Chinois',
    'fr-CA.zu': 'Zoulou',
    'fr-CA.en-US': 'Anglais (É-U)',
    'fr-CA.en-GB': 'Anglais (R-U)',
    'fr-CA.fr-FR': 'Français (FR)',
    'fr-CA.fr-CA': 'Français (CA)',
    // fr-FR: French
    'fr-FR.aa': 'Afare',
    'fr-FR.ab': 'Abkhaze',
    'fr-FR.ae': 'Avestan',
    'fr-FR.af': 'Afrikaans',
    'fr-FR.ak': 'Akan',
    'fr-FR.am': 'Amharique',
    'fr-FR.an': 'Aragonais',
    'fr-FR.ar': 'Arabe',
    'fr-FR.as': 'Assamais',
    'fr-FR.av': 'Avarique',
    'fr-FR.ay': 'Aymara',
    'fr-FR.az': 'Azerbaïdjanais du sud',
    'fr-FR.ba': 'Bachkir',
    'fr-FR.be': 'Biélorusse',
    'fr-FR.bg': 'Bulgare',
    'fr-FR.bh': 'Bihari',
    'fr-FR.bi': 'Bislama',
    'fr-FR.bm': 'Bambara',
    'fr-FR.bn': 'Bengali',
    'fr-FR.bo': 'Norme tibétaine',
    'fr-FR.br': 'Breton',
    'fr-FR.bs': 'Bosniaque',
    'fr-FR.ca': 'Catalan',
    'fr-FR.ce': 'Tchétchène',
    'fr-FR.ch': 'Chamorro',
    'fr-FR.co': 'Corse',
    'fr-FR.cr': 'Cri',
    'fr-FR.cs': 'Tchèque',
    'fr-FR.cu': 'Slave d\'église ancienne',
    'fr-FR.cv': 'Tchouvache',
    'fr-FR.cy': 'Gallois',
    'fr-FR.da': 'Danois',
    'fr-FR.de': 'Allemand',
    'fr-FR.dv': 'Divehi',
    'fr-FR.dz': 'Dzongkha',
    'fr-FR.ee': 'Brebis',
    'fr-FR.el': 'Grec, Moderne',
    'fr-FR.en': 'Anglais',
    'fr-FR.eo': 'Espéranto',
    'fr-FR.es': 'Espanol',
    'fr-FR.et': 'Estonien',
    'fr-FR.eu': 'Basque',
    'fr-FR.fa': 'Persan',
    'fr-FR.ff': 'Peul',
    'fr-FR.fi': 'Finlandais',
    'fr-FR.fj': 'Fidjien',
    'fr-FR.fo': 'Féroïen',
    'fr-FR.fr': 'Français',
    'fr-FR.fy': 'Frison occidental',
    'fr-FR.ga': 'Irlandais',
    'fr-FR.gd': 'Gaélique écossais',
    'fr-FR.gl': 'Galicien',
    'fr-FR.gn': 'Guarani',
    'fr-FR.gu': 'Gujarati',
    'fr-FR.gv': 'Mannois',
    'fr-FR.ha': 'Haoussa',
    'fr-FR.he': 'Hébreu',
    'fr-FR.iw': 'Hébreu',
    'fr-FR.hi': 'Hindi',
    'fr-FR.ho': 'Hiri Motu',
    'fr-FR.hr': 'Croate',
    'fr-FR.ht': 'Haïtien',
    'fr-FR.hu': 'Hongrois',
    'fr-FR.hy': 'Arménien',
    'fr-FR.hz': 'Héréro',
    'fr-FR.ia': 'Interlingue',
    'fr-FR.in': 'Indonésien',
    'fr-FR.ie': 'Interlingue',
    'fr-FR.ig': 'Ibo',
    'fr-FR.ii': 'Nuosu',
    'fr-FR.ik': 'Inupiaq',
    'fr-FR.io': 'Je fais',
    'fr-FR.is': 'Islandais',
    'fr-FR.it': 'Italien',
    'fr-FR.iu': 'Inuktitut',
    'fr-FR.ja': 'Japonais',
    'fr-FR.jv': 'Javanais',
    'fr-FR.ka': 'Géorgien',
    'fr-FR.kg': 'Kongo',
    'fr-FR.ki': 'Kikuyu',
    'fr-FR.kj': 'Kwanyama',
    'fr-FR.kk': 'Kazakh',
    'fr-FR.kl': 'Kalaallisout',
    'fr-FR.km': 'Khmer',
    'fr-FR.kn': 'Kannada',
    'fr-FR.ko': 'Coréen',
    'fr-FR.kr': 'Kanuri',
    'fr-FR.ks': 'Cachemire',
    'fr-FR.ku': 'Kurde',
    'fr-FR.kv': 'Komis',
    'fr-FR.kw': 'Cornouaillais',
    'fr-FR.ky': 'Kirghize',
    'fr-FR.la': 'Latin',
    'fr-FR.lb': 'Luxembourgeois',
    'fr-FR.lg': 'Ganda',
    'fr-FR.li': 'Limbourgeois',
    'fr-FR.ln': 'Lingala',
    'fr-FR.lo': 'Lao',
    'fr-FR.lt': 'Lituanien',
    'fr-FR.lu': 'Luba-Katanga',
    'fr-FR.lv': 'Letton',
    'fr-FR.mg': 'Malgache',
    'fr-FR.mh': 'Marshallais',
    'fr-FR.mi': 'Maori',
    'fr-FR.mk': 'Macédonien',
    'fr-FR.ml': 'Malayalam',
    'fr-FR.mn': 'Mongol',
    'fr-FR.mr': 'Marathi',
    'fr-FR.ms': 'Malais',
    'fr-FR.mt': 'Maltais',
    'fr-FR.my': 'Birman',
    'fr-FR.na': 'Nauru',
    'fr-FR.nb': 'Norvégien bokml',
    'fr-FR.nd': 'Nord Ndebele',
    'fr-FR.ne': 'Népalais',
    'fr-FR.ng': 'Ndonga',
    'fr-FR.nl': 'Néerlandais',
    'fr-FR.nn': 'Nynorsk norvégien',
    'fr-FR.no': 'Norvégien',
    'fr-FR.nr': 'Sud Ndebele',
    'fr-FR.nv': 'Navajo, Navaho',
    'fr-FR.ny': 'Chichewa',
    'fr-FR.oc': 'Occitan',
    'fr-FR.oj': 'Ojibwé, Ojibwé',
    'fr-FR.om': 'Galla',
    'fr-FR.or': 'Oriya',
    'fr-FR.os': 'Ossète, Ossétique',
    'fr-FR.pa': 'Panjabi, Pendjabi',
    'fr-FR.pi': 'Pali',
    'fr-FR.pl': 'Polonais',
    'fr-FR.ps': 'Pashto, Pushto',
    'fr-FR.pt': 'Portugais',
    'fr-FR.qu': 'Quechua',
    'fr-FR.rm': 'Romanche',
    'fr-FR.rn': 'Kirundi',
    'fr-FR.ro': 'Roumain',
    'fr-FR.ru': 'Russe',
    'fr-FR.rw': 'Kinyarwanda',
    'fr-FR.sa': 'Sanskrit',
    'fr-FR.sc': 'Sarde',
    'fr-FR.sd': 'Sindhi',
    'fr-FR.se': 'Sâme du Nord',
    'fr-FR.sg': 'Sango',
    'fr-FR.si': 'Cinghalais',
    'fr-FR.sk': 'Slovaque',
    'fr-FR.sl': 'Slovène',
    'fr-FR.sm': 'Samoa',
    'fr-FR.sn': 'Shona',
    'fr-FR.so': 'Somali',
    'fr-FR.sq': 'Albanais',
    'fr-FR.sr': 'Serbe',
    'fr-FR.ss': 'Swati',
    'fr-FR.st': 'Sotho du Sud',
    'fr-FR.su': 'Sundanais',
    'fr-FR.sv': 'Suédois',
    'fr-FR.sw': 'Twahili',
    'fr-FR.ta': 'Tamil',
    'fr-FR.te': 'Telugu',
    'fr-FR.tg': 'Tadjik',
    'fr-FR.th': 'Thaïlandais',
    'fr-FR.ti': 'Tigrinya',
    'fr-FR.tk': 'Turkmène',
    'fr-FR.tl': 'Tagalog',
    'fr-FR.tn': 'Tswana',
    'fr-FR.to': 'Tonga',
    'fr-FR.tr': 'Turc',
    'fr-FR.ts': 'Tsonga',
    'fr-FR.tt': 'Tatar',
    'fr-FR.tw': 'Twi',
    'fr-FR.ty': 'Tahitien',
    'fr-FR.ug': 'Ouïghour',
    'fr-FR.uk': 'Ukrainien',
    'fr-FR.ur': 'Ourdou',
    'fr-FR.uz': 'Ouzbek',
    'fr-FR.ve': 'Venda',
    'fr-FR.vi': 'Vietnamien',
    'fr-FR.vo': 'Volapík',
    'fr-FR.wa': 'Wallon',
    'fr-FR.wo': 'Wolof',
    'fr-FR.xh': 'Xhosa',
    'fr-FR.yi': 'Yiddish',
    'fr-FR.yo': 'Yoruba',
    'fr-FR.za': 'Zhuang',
    'fr-FR.zh': 'Chinois',
    'fr-FR.zu': 'Zoulou',
    'fr-FR.en-US': 'Anglais (É-U)',
    'fr-FR.en-GB': 'Anglais (R-U)',
    'fr-FR.fr-FR': 'Français (FR)',
    'fr-FR.fr-CA': 'Français (CA)',
    // German
    'de.aa': 'Fern',
    'de.ab': 'Abchasien',
    'de.ae': 'Avestan',
    'de.af': 'Afrikaans',
    'de.ak': 'Akan',
    'de.am': 'Amharisch',
    'de.an': 'Aragonesisch',
    'de.ar': 'Arabisch',
    'de.as': 'Assamesisch',
    'de.av': 'Avaric',
    'de.ay': 'Aymara',
    'de.az': 'Süd-aserbaidschanisch',
    'de.ba': 'Baschkirisch',
    'de.be': 'Belarussisch',
    'de.bg': 'Bulgarisch',
    'de.bh': 'Bihari',
    'de.bi': 'Bislama',
    'de.bm': 'Bambara',
    'de.bn': 'Bengali',
    'de.bo': 'Tibetischer Standard',
    'de.br': 'Bretonisch',
    'de.bs': 'Bosnisch',
    'de.ca': 'Katalanisch',
    'de.ce': 'Tschetschenien',
    'de.ch': 'Chamorro',
    'de.co': 'Korsisch',
    'de.cr': 'Cree',
    'de.cs': 'Tschechisch',
    'de.cu': 'Altes Kirchenslawisch',
    'de.cv': 'Tschuwaschen',
    'de.cy': 'Walisisch',
    'de.da': 'Dänisch',
    'de.de': 'Deutsch',
    'de.dv': 'Tauchhi',
    'de.dz': 'Dzongkha',
    'de.ee': 'Mutterschaf',
    'de.el': 'Griechisch, Modern',
    'de.en': 'Englisch',
    'de.eo': 'Esperanto',
    'de.es': 'Spanisch',
    'de.et': 'Estnisch',
    'de.eu': 'Baskisch',
    'de.fa': 'Persisch',
    'de.ff': 'Fula',
    'de.fi': 'Finnisch',
    'de.fj': 'Fidschian',
    'de.fo': 'Färöisch',
    'de.fr': 'Französisch',
    'de.fy': 'Westfriesisch',
    'de.ga': 'Irisch',
    'de.gd': 'Schottisch Gälisch',
    'de.gl': 'Galizisch',
    'de.gn': 'Guarani',
    'de.gu': 'Gujarati',
    'de.gv': 'Manx',
    'de.ha': 'Hausa',
    'de.he': 'Hebräisch',
    'de.iw': 'Hebräisch',
    'de.hi': 'Hindi',
    'de.ho': 'Hiri Motu',
    'de.hr': 'Kroatisch',
    'de.ht': 'Haitianisch',
    'de.hu': 'Ungarisch',
    'de.hy': 'Armenisch',
    'de.hz': 'Herero',
    'de.ia': 'Interlingua',
    'de.in': 'Indonesisch',
    'de.ie': 'Zwischensprache',
    'de.ig': 'Igbo',
    'de.ii': 'Nuosu',
    'de.ik': 'Inupiaq',
    'de.io': 'Das Tue Ich',
    'de.is': 'Isländisch',
    'de.it': 'Italienisch',
    'de.iu': 'Inuktitut',
    'de.ja': 'Japanisch',
    'de.jv': 'Javanisch',
    'de.ka': 'Georgisch',
    'de.kg': 'Kongo',
    'de.ki': 'Kikuyu',
    'de.kj': 'Kwanyama',
    'de.kk': 'Kasachisch',
    'de.kl': 'Kalaallisut',
    'de.km': 'Khmer',
    'de.kn': 'Kannada',
    'de.ko': 'Koreanisch',
    'de.kr': 'Kanuri',
    'de.ks': 'Kaschmir',
    'de.ku': 'Kurdisch',
    'de.kv': 'Komi',
    'de.kw': 'Kornisch',
    'de.ky': 'Kirgisisch',
    'de.la': 'Latein',
    'de.lb': 'Luxemburgisch',
    'de.lg': 'Ganda',
    'de.li': 'Limburgisch',
    'de.ln': 'Lingala',
    'de.lo': 'Laos',
    'de.lt': 'Litauisch',
    'de.lu': 'Luba-katanga',
    'de.lv': 'Lettisch',
    'de.mg': 'Madagassisch',
    'de.mh': 'Marshallesisch',
    'de.mi': 'Maori',
    'de.mk': 'Mazedonisch',
    'de.ml': 'Malayalam',
    'de.mn': 'Mongolisch',
    'de.mr': 'Marathi',
    'de.ms': 'Malaiisch',
    'de.mt': 'Maltesisch',
    'de.my': 'Birmanisch',
    'de.na': 'Nauru',
    'de.nb': 'Norwegisches Bokmål',
    'de.nd': 'Nord-ndebele',
    'de.ne': 'Nepalesisch',
    'de.ng': 'Ndonga',
    'de.nl': 'Niederländisch',
    'de.nn': 'Norwegisch Nynorsk',
    'de.no': 'Norwegisch',
    'de.nr': 'Süd-ndebele',
    'de.nv': 'Navajo, Navaho',
    'de.ny': 'Chichewa',
    'de.oc': 'Okzitanisch',
    'de.oj': 'Ojibwe, Ojibwa',
    'de.om': 'Oromo',
    'de.or': 'Oriya',
    'de.os': 'Ossetisch, Ossetisch',
    'de.pa': 'Panjabi, Punjabi',
    'de.pi': 'Pali',
    'de.pl': 'Polieren',
    'de.ps': 'Pashto, Pushto',
    'de.pt': 'Portugiesisch',
    'de.qu': 'Quechua',
    'de.rm': 'Rätoromanisch',
    'de.rn': 'Kirundi',
    'de.ro': 'Rumänisch',
    'de.ru': 'Russisch',
    'de.rw': 'Kinyarwanda',
    'de.sa': 'Sanskrit',
    'de.sc': 'Sardisch',
    'de.sd': 'Sindhi',
    'de.se': 'Nordsamisch',
    'de.sg': 'Sango',
    'de.si': 'Singhalesisch',
    'de.sk': 'Slowakisch',
    'de.sl': 'Slowenisch',
    'de.sm': 'Samoanisch',
    'de.sn': 'Shona',
    'de.so': 'Somali',
    'de.sq': 'Albanisch',
    'de.sr': 'Serbisch',
    'de.ss': 'Swati',
    'de.st': 'Süd-sotho',
    'de.su': 'Sundanesisch',
    'de.sv': 'Schwedisch',
    'de.sw': 'Swahili',
    'de.ta': 'Tamil',
    'de.te': 'Telugu',
    'de.tg': 'Tadschikisch',
    'de.th': 'Thai',
    'de.ti': 'Tigrinya',
    'de.tk': 'Turkmenisch',
    'de.tl': 'Tagalog',
    'de.tn': 'Tswana',
    'de.to': 'Tonga',
    'de.tr': 'Türkisch',
    'de.ts': 'Tsonga',
    'de.tt': 'Tataren',
    'de.tw': 'Zwei',
    'de.ty': 'Tahiti',
    'de.ug': 'Uiguren',
    'de.uk': 'Ukrainisch',
    'de.ur': 'Urdu',
    'de.uz': 'Usbekisch',
    'de.ve': 'Venda',
    'de.vi': 'Vietnamesisch',
    'de.vo': 'Volapãk',
    'de.wa': 'Wallonisch',
    'de.wo': 'Wolof',
    'de.xh': 'Xhosa',
    'de.yi': 'Jiddisch',
    'de.yo': 'Yoruba',
    'de.za': 'Zhuang',
    'de.zh': 'Chinesisch',
    'de.zu': 'Zulu',
    'de.en-US': 'Englisch',
    'de.en-GB': 'Englisch',
    'de.fr-FR': 'Französisch',
    'de.fr-CA': 'Französisch',
    // Danish
    'da.aa': 'Afar',
    'da.ab': 'Abkhaz',
    'da.ae': 'Avestan',
    'da.af': 'Afrikaans',
    'da.ak': 'Akan',
    'da.am': 'Amharisk',
    'da.an': 'Aragonese',
    'da.ar': 'Arabisk',
    'da.as': 'Assamesisk',
    'da.av': 'Avarisk',
    'da.ay': 'Aymara',
    'da.az': 'Sydaserbajdsjansk',
    'da.ba': 'Bashkir',
    'da.be': 'Hviderussisk',
    'da.bg': 'Bulgarsk',
    'da.bh': 'Bihari',
    'da.bi': 'Bislama',
    'da.bm': 'Bambara',
    'da.bn': 'Bengali',
    'da.bo': 'Tibetansk Standard',
    'da.br': 'Bretonsk',
    'da.bs': 'Bosnisk',
    'da.ca': 'Catalansk',
    'da.ce': 'Tjetjensk',
    'da.ch': 'Chamorro',
    'da.co': 'Korsikansk',
    'da.cr': 'Cree',
    'da.cs': 'Tjekkisk',
    'da.cu': 'Gamle Kirkeslaviske',
    'da.cv': 'Chuvash',
    'da.cy': 'Walisisk',
    'da.da': 'Dansk',
    'da.de': 'Tysk',
    'da.dv': 'Divehi',
    'da.dz': 'Dzongkha',
    'da.ee': 'Ewe',
    'da.el': 'Græsk, Moderne',
    'da.en': 'Engelsk',
    'da.eo': 'Esperanto',
    'da.es': 'Spansk',
    'da.et': 'Estisk',
    'da.eu': 'Baskisk',
    'da.fa': 'Persisk',
    'da.ff': 'Fula',
    'da.fi': 'Finsk',
    'da.fj': 'Fijiansk',
    'da.fo': 'Færøsk',
    'da.fr': 'Fransk',
    'da.fy': 'Vestfrisisk',
    'da.ga': 'Irsk',
    'da.gd': 'Skotsk Gælisk',
    'da.gl': 'Galicisk',
    'da.gn': 'Guarani',
    'da.gu': 'Gujarati',
    'da.gv': 'Manx',
    'da.ha': 'Hausa',
    'da.he': 'Hebraisk',
    'da.iw': 'Hebraisk',
    'da.hi': 'Hindi',
    'da.ho': 'Hiri Motu',
    'da.hr': 'Kroatisk',
    'da.ht': 'Haitisk',
    'da.hu': 'Ungarsk',
    'da.hy': 'Armensk',
    'da.hz': 'Herero',
    'da.ia': 'Interlingua',
    'da.in': 'Indonesisk',
    'da.ie': 'Interlingue',
    'da.ig': 'Igbo',
    'da.ii': 'Nuosu',
    'da.ik': 'Inupiaq',
    'da.io': 'Jeg Gør',
    'da.is': 'Islandsk',
    'da.it': 'Italiensk',
    'da.iu': 'Inuktitut',
    'da.ja': 'Japansk',
    'da.jv': 'Javanesisk',
    'da.ka': 'Georgisk',
    'da.kg': 'Kongo',
    'da.ki': 'Kikuyu',
    'da.kj': 'Kwanyama',
    'da.kk': 'Kasakhisk',
    'da.kl': 'Kalaallisut',
    'da.km': 'Khmer',
    'da.kn': 'Kannada',
    'da.ko': 'Koreansk',
    'da.kr': 'Kanuri',
    'da.ks': 'Kashmiri',
    'da.ku': 'Kurdisk',
    'da.kv': 'Komi',
    'da.kw': 'Cornish',
    'da.ky': 'Kirgisisk',
    'da.la': 'Latin',
    'da.lb': 'Luxemburgsk',
    'da.lg': 'Ganda',
    'da.li': 'Limburgsk',
    'da.ln': 'Lingala',
    'da.lo': 'Lao',
    'da.lt': 'Litauisk',
    'da.lu': 'Luba-katanga',
    'da.lv': 'Lettisk',
    'da.mg': 'Madagaskisk',
    'da.mh': 'Marshallsk',
    'da.mi': 'Maori',
    'da.mk': 'Makedonsk',
    'da.ml': 'Malayalam',
    'da.mn': 'Mongolsk',
    'da.mr': 'Marathi',
    'da.ms': 'Malaysisk',
    'da.mt': 'Malteser',
    'da.my': 'Burmesisk',
    'da.na': 'Nauru',
    'da.nb': 'Norsk Bokmål',
    'da.nd': 'Nord -ndebele',
    'da.ne': 'Nepalesisk',
    'da.ng': 'Ndonga',
    'da.nl': 'Hollandske',
    'da.nn': 'Norsk Nynorsk',
    'da.no': 'Norsk',
    'da.nr': 'Sydndebele',
    'da.nv': 'Navajo, Navaho',
    'da.ny': 'Chichewa',
    'da.oc': 'Occitansk',
    'da.oj': 'Ojibwe, Ojibwa',
    'da.om': 'Oromo',
    'da.or': 'Oriya',
    'da.os': 'Ossetisk, Ossetisk',
    'da.pa': 'Panjabi, Punjabi',
    'da.pi': 'Pali',
    'da.pl': 'Polere',
    'da.ps': 'Pashto, Pushto',
    'da.pt': 'Portugisisk',
    'da.qu': 'Quechua',
    'da.rm': 'Romersk',
    'da.rn': 'Kirundi',
    'da.ro': 'Rumænsk',
    'da.ru': 'Russisk',
    'da.rw': 'Kinyarwanda',
    'da.sa': 'Sanskrit',
    'da.sc': 'Sardinsk',
    'da.sd': 'Sindhi',
    'da.se': 'Nordsamer',
    'da.sg': 'Sango',
    'da.si': 'Singalesisk',
    'da.sk': 'Slovakisk',
    'da.sl': 'Slovensk',
    'da.sm': 'Samoansk',
    'da.sn': 'Shona',
    'da.so': 'Somalisk',
    'da.sq': 'Albansk',
    'da.sr': 'Serbisk',
    'da.ss': 'Swati',
    'da.st': 'Sydsotho',
    'da.su': 'Sundanesisk',
    'da.sv': 'Svensk',
    'da.sw': 'Swahili',
    'da.ta': 'Tamil',
    'da.te': 'Telugu',
    'da.tg': 'Tadsjikisk',
    'da.th': 'Thai',
    'da.ti': 'Tigrinya',
    'da.tk': 'Turkmenere',
    'da.tl': 'Tagalog',
    'da.tn': 'Tswana',
    'da.to': 'Tonga',
    'da.tr': 'Tyrkisk',
    'da.ts': 'Tsonga',
    'da.tt': 'Tatarisk',
    'da.tw': 'Twi',
    'da.ty': 'Tahitisk',
    'da.ug': 'Uyghur',
    'da.uk': 'Ukrainsk',
    'da.ur': 'Urdu',
    'da.uz': 'Usbekisk',
    'da.ve': 'Venda',
    'da.vi': 'Vietnamesisk',
    'da.vo': 'Volapãk',
    'da.wa': 'Vallonsk',
    'da.wo': 'Wolof',
    'da.xh': 'Xhosa',
    'da.yi': 'Jiddisch',
    'da.yo': 'Yoruba',
    'da.za': 'Zhuang',
    'da.zh': 'Kinesisk',
    'da.zu': 'Zulu',
    'da.en-US': 'Engelsk',
    'da.en-GB': 'Engelsk',
    'da.fr-FR': 'Fransk',
    'da.fr-CA': 'Fransk',
    // Dutch
    'nl.aa': 'Afar',
    'nl.ab': 'Abchazisch',
    'nl.ae': 'Avestan',
    'nl.af': 'Afrikaans',
    'nl.ak': 'Akani',
    'nl.am': 'Amhaars',
    'nl.an': 'Aragonees',
    'nl.ar': 'Arabisch',
    'nl.as': 'Assamees',
    'nl.av': 'hebzuchtig',
    'nl.ay': 'Aymara',
    'nl.az': 'Zuid-Azerbeidzjaans',
    'nl.ba': 'Bashkir',
    'nl.be': 'Wit-Russisch',
    'nl.bg': 'Bulgaars',
    'nl.bh': 'Bihari',
    'nl.bi': 'Bislama',
    'nl.bm': 'Bambara',
    'nl.bn': 'Bengaals',
    'nl.bo': 'Tibetaanse standaard',
    'nl.br': 'Breton',
    'nl.bs': 'Bosnisch',
    'nl.ca': 'Catalaans',
    'nl.ce': 'Tsjetsjeens',
    'nl.ch': 'Chamorro',
    'nl.co': 'Corsicaans',
    'nl.cr': 'Cree',
    'nl.cs': 'Tsjechisch',
    'nl.cu': 'Oudkerkslavisch',
    'nl.cv': 'Tsjoevasj',
    'nl.cy': 'Welsh',
    'nl.da': 'Deens',
    'nl.de': 'Duitse',
    'nl.dv': 'Duikhi',
    'nl.dz': 'Dzongkha',
    'nl.ee': 'Ooi',
    'nl.el': 'Grieks, Modern',
    'nl.en': 'Engels',
    'nl.eo': 'Esperanto',
    'nl.es': 'Spaans',
    'nl.et': 'Ests',
    'nl.eu': 'baskisch',
    'nl.fa': 'Perzisch',
    'nl.ff': 'Fula',
    'nl.fi': 'Fins',
    'nl.fj': 'Fiji',
    'nl.fo': 'Faeröers',
    'nl.fr': 'Frans',
    'nl.fy': 'West-Fries',
    'nl.ga': 'Iers',
    'nl.gd': 'Schots-Gaelisch',
    'nl.gl': 'Galicisch',
    'nl.gn': 'Guaraní',
    'nl.gu': 'Gujarati',
    'nl.gv': 'Manx',
    'nl.ha': 'Hausa',
    'nl.he': 'Hebreeuws',
    'nl.iw': 'Hebreeuws',
    'nl.hi': 'Hindi',
    'nl.ho': 'Hiri Motu',
    'nl.hr': 'Kroatisch',
    'nl.ht': 'Haïtiaans',
    'nl.hu': 'Hongaars',
    'nl.hy': 'Armeens',
    'nl.hz': 'Herero',
    'nl.ia': 'Interlingua',
    'nl.in': 'Indonesisch',
    'nl.ie': 'Interlingue',
    'nl.ig': 'Igbo',
    'nl.ii': 'Nuosu',
    'nl.ik': 'Inupiaq',
    'nl.io': 'Ik doe',
    'nl.is': 'IJslands',
    'nl.it': 'Italiaans',
    'nl.iu': 'Inuktitut',
    'nl.ja': 'Japans',
    'nl.jv': 'Javaans',
    'nl.ka': 'Georgisch',
    'nl.kg': 'Kongo',
    'nl.ki': 'Kikuyu',
    'nl.kj': 'Kwanyama',
    'nl.kk': 'Kazachs',
    'nl.kl': 'Kalaallisut',
    'nl.km': 'Khmer',
    'nl.kn': 'Kannada',
    'nl.ko': 'Koreaans',
    'nl.kr': 'Kanuri',
    'nl.ks': 'Kasjmir',
    'nl.ku': 'Koerdisch',
    'nl.kv': 'Komi',
    'nl.kw': 'Cornish',
    'nl.ky': 'Kirgizië',
    'nl.la': 'Latijns',
    'nl.lb': 'Luxemburgs',
    'nl.lg': 'Ganda',
    'nl.li': 'Limburgs',
    'nl.ln': 'Lingala',
    'nl.lo': 'Laos',
    'nl.lt': 'Litouws',
    'nl.lu': 'Luba-Katanga',
    'nl.lv': 'Lets',
    'nl.mg': 'Madagaskar-',
    'nl.mh': 'Marshallees',
    'nl.mi': 'Maori-',
    'nl.mk': 'Macedonisch',
    'nl.ml': 'Malayalam',
    'nl.mn': 'Mongools',
    'nl.mr': 'Marathi',
    'nl.ms': 'Maleis-',
    'nl.mt': 'Maltees',
    'nl.my': 'Birmees',
    'nl.na': 'Nauru',
    'nl.nb': 'Noorse Bokmål',
    'nl.nd': 'Noord Ndebele',
    'nl.ne': 'Nepalees',
    'nl.ng': 'Ndonga',
    'nl.nl': 'Nederlands',
    'nl.nn': 'Noorse Nynorsk',
    'nl.no': 'Noors',
    'nl.nr': 'Zuid Ndebele',
    'nl.nv': 'Navajo, Navaho',
    'nl.ny': 'Chichewa',
    'nl.oc': 'Occitaans',
    'nl.oj': 'Ojibwe, Ojibwa',
    'nl.om': 'Oromo',
    'nl.or': 'Oriya',
    'nl.os': 'Ossetisch, Ossetisch',
    'nl.pa': 'Panjabi, Punjabi',
    'nl.pi': 'Pali',
    'nl.pl': 'Pools',
    'nl.ps': 'Pashto, Pushto',
    'nl.pt': 'Portugees',
    'nl.qu': 'Quechua',
    'nl.rm': 'Reto-Romaans',
    'nl.rn': 'Kirundi',
    'nl.ro': 'Roemeense',
    'nl.ru': 'Russisch',
    'nl.rw': 'Kinyarwanda',
    'nl.sa': 'Sanskriet-',
    'nl.sc': 'Sardinisch',
    'nl.sd': 'Sindhi',
    'nl.se': 'Noord-Samic',
    'nl.sg': 'Sango',
    'nl.si': 'Sinhala',
    'nl.sk': 'Slowaaks',
    'nl.sl': 'Sloveens',
    'nl.sm': 'Samoaans',
    'nl.sn': 'Shona',
    'nl.so': 'Somalisch',
    'nl.sq': 'Albanees',
    'nl.sr': 'Servisch',
    'nl.ss': 'Swati',
    'nl.st': 'Zuid-Sotho',
    'nl.su': 'Soendanees',
    'nl.sv': 'Zweeds',
    'nl.sw': 'Swahili',
    'nl.ta': 'Tamil',
    'nl.te': 'Telugu',
    'nl.tg': 'Tadzjiekse',
    'nl.th': 'Thais',
    'nl.ti': 'Tigrinya',
    'nl.tk': 'Turkmeens',
    'nl.tl': 'Tagalog',
    'nl.tn': 'Tswana',
    'nl.to': 'Tonga',
    'nl.tr': 'Turks',
    'nl.ts': 'Tsonga',
    'nl.tt': 'Tataars',
    'nl.tw': 'twee keer',
    'nl.ty': 'Tahitiaans',
    'nl.ug': 'Oeigoerse',
    'nl.uk': 'Oekraïens',
    'nl.ur': 'Urdu',
    'nl.uz': 'Oezbeeks',
    'nl.ve': 'Venda',
    'nl.vi': 'Vietnamees',
    'nl.vo': 'Volapík',
    'nl.wa': 'Waals',
    'nl.wo': 'Wolof',
    'nl.xh': 'Xhosa',
    'nl.yi': 'Jiddisch',
    'nl.yo': 'Yoruba',
    'nl.za': 'Zhuang',
    'nl.zh': 'Chinese',
    'nl.zu': 'Zulu',
    'nl.en-US': 'Engels',
    'nl.en-GB': 'Engels',
    'nl.fr-FR': 'Frans',
    'nl.fr-CA': 'Frans',
    // Finnish
    'fi.aa': 'Afar',
    'fi.ab': 'Abhas',
    'fi.ae': 'Avestan',
    'fi.af': 'Afrikaans',
    'fi.ak': 'Akan',
    'fi.am': 'Amhara',
    'fi.an': 'Aragonialainen',
    'fi.ar': 'Arabialainen',
    'fi.as': 'Assamia',
    'fi.av': 'Epävarma',
    'fi.ay': 'Aymara',
    'fi.az': 'Etelä -azerbaidžan',
    'fi.ba': 'Bashkir',
    'fi.be': 'Valkovenäjä',
    'fi.bg': 'Bulgaria',
    'fi.bh': 'Bihari',
    'fi.bi': 'Bislama',
    'fi.bm': 'Bambara',
    'fi.bn': 'Bengali',
    'fi.bo': 'Tiibetin Standardi',
    'fi.br': 'Breton',
    'fi.bs': 'Bosnialainen',
    'fi.ca': 'Katalaani',
    'fi.ce': 'Tšetšeeni',
    'fi.ch': 'Chamorro',
    'fi.co': 'Korsikalainen',
    'fi.cr': 'Cree',
    'fi.cs': 'Tšekki',
    'fi.cu': 'Vanha Kirkon Slaavilainen',
    'fi.cv': 'Chuvash',
    'fi.cy': 'Walesin',
    'fi.da': 'Tanskan Kieli',
    'fi.de': 'Saksan Kieli',
    'fi.dv': 'Divehi',
    'fi.dz': 'Dzongkha',
    'fi.ee': 'Uuhi',
    'fi.el': 'Kreikkalainen, Moderni',
    'fi.en': 'Englanti',
    'fi.eo': 'Esperanto',
    'fi.es': 'Espanja',
    'fi.et': 'Virolainen',
    'fi.eu': 'Baski',
    'fi.fa': 'Persialainen',
    'fi.ff': 'Fula',
    'fi.fi': 'Suomalainen',
    'fi.fj': 'Fidži',
    'fi.fo': 'Färsaaret',
    'fi.fr': 'Ranskan Kieli',
    'fi.fy': 'Länsi-friisi',
    'fi.ga': 'Irlantilainen',
    'fi.gd': 'Skotlantilainen Gaeli',
    'fi.gl': 'Galician',
    'fi.gn': 'Guarani',
    'fi.gu': 'Gujarati',
    'fi.gv': 'Manx',
    'fi.ha': 'Hausa',
    'fi.he': 'Heprealainen',
    'fi.iw': 'Heprealainen',
    'fi.hi': 'Hindi',
    'fi.ho': 'Hiri Motu',
    'fi.hr': 'Kroatialainen',
    'fi.ht': 'Haitin',
    'fi.hu': 'Unkarin Kieli',
    'fi.hy': 'Armenialainen',
    'fi.hz': 'Herero',
    'fi.ia': 'Interlingua',
    'fi.in': 'Indonesialainen',
    'fi.ie': 'Interlingue',
    'fi.ig': 'Igbo',
    'fi.ii': 'Nuosu',
    'fi.ik': 'Inupiaq',
    'fi.io': 'Tahdon',
    'fi.is': 'Islantilainen',
    'fi.it': 'Italialainen',
    'fi.iu': 'Inuktitut',
    'fi.ja': 'Japanilainen',
    'fi.jv': 'Jaavalainen',
    'fi.ka': 'Georgian',
    'fi.kg': 'Kongo',
    'fi.ki': 'Kikuyu',
    'fi.kj': 'Kwanyama',
    'fi.kk': 'Kazakstan',
    'fi.kl': 'Kalaallisut',
    'fi.km': 'Khmer',
    'fi.kn': 'Kannada',
    'fi.ko': 'Korealainen',
    'fi.kr': 'Kanuri',
    'fi.ks': 'Kashmiri',
    'fi.ku': 'Kurdi',
    'fi.kv': 'Komi',
    'fi.kw': 'Cornish',
    'fi.ky': 'Kirgisia',
    'fi.la': 'Latinan Kieli',
    'fi.lb': 'Luxemburgilainen',
    'fi.lg': 'Ganda',
    'fi.li': 'Limburgilainen',
    'fi.ln': 'Lingala',
    'fi.lo': 'Lao',
    'fi.lt': 'Liettua',
    'fi.lu': 'Luba-katanga',
    'fi.lv': 'Latvialainen',
    'fi.mg': 'Madagaskar',
    'fi.mh': 'Marsalkka',
    'fi.mi': 'Maori',
    'fi.mk': 'Makedonialainen',
    'fi.ml': 'Malajalam',
    'fi.mn': 'Mongolialainen',
    'fi.mr': 'Marathi',
    'fi.ms': 'Malaiji',
    'fi.mt': 'Maltalainen',
    'fi.my': 'Burmalainen',
    'fi.na': 'Nauru',
    'fi.nb': 'Norjalainen Kirja',
    'fi.nd': 'Pohjois -ndebele',
    'fi.ne': 'Nepalilainen',
    'fi.ng': 'Ndonga',
    'fi.nl': 'Hollannin Kieli',
    'fi.nn': 'Norjalainen Nynorsk',
    'fi.no': 'Norjan Kieli',
    'fi.nr': 'Etelä -ndebele',
    'fi.nv': 'Navajo, Navaho',
    'fi.ny': 'Chichewa',
    'fi.oc': 'Oksitaani',
    'fi.oj': 'Ojibwe, Ojibwa',
    'fi.om': 'Oromo',
    'fi.or': 'Oriya',
    'fi.os': 'Ossetian, Ossetic',
    'fi.pa': 'Panjabi, Punjabi',
    'fi.pi': 'Pali',
    'fi.pl': 'Kiillottaa',
    'fi.ps': 'Pashto, Pushto',
    'fi.pt': 'Portugalin Kieli',
    'fi.qu': 'Quechua',
    'fi.rm': 'Roomalainen',
    'fi.rn': 'Kirundi',
    'fi.ro': 'Romanialainen',
    'fi.ru': 'Venäjän Kieli',
    'fi.rw': 'Kinyarwanda',
    'fi.sa': 'Sanskrit',
    'fi.sc': 'Sardinian',
    'fi.sd': 'Sindhi',
    'fi.se': 'Pohjoissaame',
    'fi.sg': 'Sango',
    'fi.si': 'Sinhala',
    'fi.sk': 'Slovakian',
    'fi.sl': 'Slovenian',
    'fi.sm': 'Samoalainen',
    'fi.sn': 'Shona',
    'fi.so': 'Somali',
    'fi.sq': 'Albanialainen',
    'fi.sr': 'Serbialainen',
    'fi.ss': 'Swati',
    'fi.st': 'Etelä -sotho',
    'fi.su': 'Sundanese',
    'fi.sv': 'Ruotsin Kieli',
    'fi.sw': 'Swahili',
    'fi.ta': 'Tamili',
    'fi.te': 'Telugu',
    'fi.tg': 'Tadžik',
    'fi.th': 'Thai',
    'fi.ti': 'Tigrinya',
    'fi.tk': 'Turkmenistan',
    'fi.tl': 'Tagalog',
    'fi.tn': 'Tswana',
    'fi.to': 'Tonga',
    'fi.tr': 'Turkki',
    'fi.ts': 'Tsonga',
    'fi.tt': 'Tataari',
    'fi.tw': 'Twi',
    'fi.ty': 'Tahitian',
    'fi.ug': 'Uiguuri',
    'fi.uk': 'Ukrainalainen',
    'fi.ur': 'Urdu',
    'fi.uz': 'Uzbekki',
    'fi.ve': 'Venda',
    'fi.vi': 'Vietnam',
    'fi.vo': 'Volapãk',
    'fi.wa': 'Vallonian',
    'fi.wo': 'Wolof',
    'fi.xh': 'Xhosa',
    'fi.yi': 'Jiddiš',
    'fi.yo': 'Joruba',
    'fi.za': 'Zhuang',
    'fi.zh': 'Kiinalainen',
    'fi.zu': 'Zulu',
    'fi.en-US': 'Englanti',
    'fi.en-GB': 'Englanti',
    'fi.fr-FR': 'Ranskan Kieli',
    'fi.fr-CA': 'Ranskan Kieli',
    // Italian
    'it.aa': 'Afar',
    'it.ab': 'Abkhaz',
    'it.ae': 'Avestan',
    'it.af': 'Afrikaans',
    'it.ak': 'Akan',
    'it.am': 'Amarico',
    'it.an': 'Aragonese',
    'it.ar': 'Arabo',
    'it.as': 'Assamese',
    'it.av': 'Avarico',
    'it.ay': 'Aymara',
    'it.az': 'Azerbaigian Meridionale',
    'it.ba': 'Bashkir',
    'it.be': 'Bielorusso',
    'it.bg': 'Bulgaro',
    'it.bh': 'Bihari',
    'it.bi': 'Bislama',
    'it.bm': 'Bambara',
    'it.bn': 'Bengalese',
    'it.bo': 'Standard Tibetano',
    'it.br': 'Bretone',
    'it.bs': 'Bosniaco',
    'it.ca': 'Catalano',
    'it.ce': 'Ceceno',
    'it.ch': 'Chamorro',
    'it.co': 'Corso',
    'it.cr': 'Cree',
    'it.cs': 'Ceco',
    'it.cu': 'Slavo Ecclesiastico Antico',
    'it.cv': 'Chuvash',
    'it.cy': 'Gallese',
    'it.da': 'Danese',
    'it.de': 'Tedesco',
    'it.dv': 'Divehi',
    'it.dz': 'Dzongkha',
    'it.ee': 'Pecora',
    'it.el': 'Greca, Moderna',
    'it.en': 'Inglese',
    'it.eo': 'Esperanto',
    'it.es': 'Spagnolo',
    'it.et': 'Estone',
    'it.eu': 'Basco',
    'it.fa': 'Persiano',
    'it.ff': 'Fula',
    'it.fi': 'Finlandese',
    'it.fj': 'Figiano',
    'it.fo': 'Faroese',
    'it.fr': 'Francese',
    'it.fy': 'Frisone Occidentale',
    'it.ga': 'Irlandesi',
    'it.gd': 'Gaelico Scozzese',
    'it.gl': 'Galiziano',
    'it.gn': 'Guaranì',
    'it.gu': 'Gujarati',
    'it.gv': 'Manx',
    'it.ha': 'Hausa',
    'it.he': 'Ebraico',
    'it.iw': 'Ebraico',
    'it.hi': 'Hindi',
    'it.ho': 'Hiri Motu',
    'it.hr': 'Croato',
    'it.ht': 'Haitiano',
    'it.hu': 'Ungherese',
    'it.hy': 'Armeno',
    'it.hz': 'Herero',
    'it.ia': 'Interlingua',
    'it.in': 'Indonesiano',
    'it.ie': 'Interlingue',
    'it.ig': 'Igbo',
    'it.ii': 'Nuosu',
    'it.ik': 'Inupiaq',
    'it.io': 'Io Faccio',
    'it.is': 'Islandese',
    'it.it': 'Italiano',
    'it.iu': 'Inuktitut',
    'it.ja': 'Giapponese',
    'it.jv': 'Giavanese',
    'it.ka': 'Georgiano',
    'it.kg': 'Kongo',
    'it.ki': 'Kikuyu',
    'it.kj': 'Kwanyama',
    'it.kk': 'Kazako',
    'it.kl': 'Kalaallisut',
    'it.km': 'Khmer',
    'it.kn': 'Kannada',
    'it.ko': 'Coreano',
    'it.kr': 'Kanuri',
    'it.ks': 'Kashmir',
    'it.ku': 'Curdo',
    'it.kv': 'Komi',
    'it.kw': 'Cornovaglia',
    'it.ky': 'Kirghizistan',
    'it.la': 'Latino',
    'it.lb': 'Lussemburghese',
    'it.lg': 'Ganda',
    'it.li': 'Limburghese',
    'it.ln': 'Lingala',
    'it.lo': 'Lao',
    'it.lt': 'Lituano',
    'it.lu': 'Luba-katanga',
    'it.lv': 'Lettone',
    'it.mg': 'Malgascio',
    'it.mh': 'Marshallese',
    'it.mi': 'Maori',
    'it.mk': 'Macedone',
    'it.ml': 'Malayalam',
    'it.mn': 'Mongolo',
    'it.mr': 'Marathi',
    'it.ms': 'Malese',
    'it.mt': 'Maltese',
    'it.my': 'Birmano',
    'it.na': 'Nauru',
    'it.nb': 'Bokmål . Norvegese',
    'it.nd': 'Nord Ndebele',
    'it.ne': 'Nepalese',
    'it.ng': 'Ndonga',
    'it.nl': 'Olandese',
    'it.nn': 'Norvegese Nynorsk',
    'it.no': 'Norvegese',
    'it.nr': 'Sud Ndebele',
    'it.nv': 'Navajo, Navaho',
    'it.ny': 'Chichewa',
    'it.oc': 'Occitano',
    'it.oj': 'Ojibwe, Ojibwa',
    'it.om': 'Oromo',
    'it.or': 'Oriya',
    'it.os': 'Osseta, Osseta',
    'it.pa': 'Panjabi, Punjabi',
    'it.pi': 'Pali',
    'it.pl': 'Polacco',
    'it.ps': 'Pashto, Pushto',
    'it.pt': 'Portoghese',
    'it.qu': 'Quechua',
    'it.rm': 'Romancio',
    'it.rn': 'Kirundi',
    'it.ro': 'Rumeno',
    'it.ru': 'Russo',
    'it.rw': 'Kinyarwanda',
    'it.sa': 'Sanscrito',
    'it.sc': 'Sardo',
    'it.sd': 'Sindhi',
    'it.se': 'Sami Del Nord',
    'it.sg': 'Sango',
    'it.si': 'Singalese',
    'it.sk': 'Slovacco',
    'it.sl': 'Sloveno',
    'it.sm': 'Samoano',
    'it.sn': 'Shona',
    'it.so': 'Somalo',
    'it.sq': 'Albanese',
    'it.sr': 'Serbo',
    'it.ss': 'Swati',
    'it.st': 'Sotho Meridionale',
    'it.su': 'Sundanese',
    'it.sv': 'Svedese',
    'it.sw': 'Swahili',
    'it.ta': 'Tamil',
    'it.te': 'Telugu',
    'it.tg': 'Tagiko',
    'it.th': 'Tailandese',
    'it.ti': 'Tigrino',
    'it.tk': 'Turkmeno',
    'it.tl': 'Tagalog',
    'it.tn': 'Tswana',
    'it.to': 'Tonga',
    'it.tr': 'Turco',
    'it.ts': 'Tsonga',
    'it.tt': 'Tataro',
    'it.tw': 'Twi',
    'it.ty': 'Tahitiano',
    'it.ug': 'Uiguro',
    'it.uk': 'Ucraino',
    'it.ur': 'Urdu',
    'it.uz': 'Uzbeko',
    'it.ve': 'Venda',
    'it.vi': 'Vietnamita',
    'it.vo': 'Volapík',
    'it.wa': 'Vallone',
    'it.wo': 'Wolof',
    'it.xh': 'Xhosa',
    'it.yi': 'Yiddish',
    'it.yo': 'Yoruba',
    'it.za': 'Zhuang',
    'it.zh': 'Cinese',
    'it.zu': 'Zulu',
    'it.en-US': 'Inglese',
    'it.en-GB': 'Inglese',
    'it.fr-FR': 'Francese',
    'it.fr-CA': 'Francese',
    // Nowegian (Bokmål)
    'nb.aa': 'Afar',
    'nb.ab': 'Abkhaz',
    'nb.ae': 'Avestan',
    'nb.af': 'Afrikaans',
    'nb.ak': 'Akan',
    'nb.am': 'Amharisk',
    'nb.an': 'Aragonese',
    'nb.ar': 'Arabisk',
    'nb.as': 'Assamisk',
    'nb.av': 'Avarisk',
    'nb.ay': 'Aymara',
    'nb.az': 'Sør -aserbajdsjansk',
    'nb.ba': 'Basjkir',
    'nb.be': 'Hviterussisk',
    'nb.bg': 'Bulgarsk',
    'nb.bh': 'Bihari',
    'nb.bi': 'Bislama',
    'nb.bm': 'Bambara',
    'nb.bn': 'Bengali',
    'nb.bo': 'Tibetansk Standard',
    'nb.br': 'Bretonsk',
    'nb.bs': 'Bosnisk',
    'nb.ca': 'Katalansk',
    'nb.ce': 'Tsjetsjensk',
    'nb.ch': 'Chamorro',
    'nb.co': 'Korsikansk',
    'nb.cr': 'Cree',
    'nb.cs': 'Tsjekkisk',
    'nb.cu': 'Old Church Slavonic',
    'nb.cv': 'Chuvash',
    'nb.cy': 'Walisisk',
    'nb.da': 'Dansk',
    'nb.de': 'Tysk',
    'nb.dv': 'Divehi',
    'nb.dz': 'Dzongkha',
    'nb.ee': 'Ewe',
    'nb.el': 'Gresk, Moderne',
    'nb.en': 'Engelsk',
    'nb.eo': 'Esperanto',
    'nb.es': 'Spansk',
    'nb.et': 'Estisk',
    'nb.eu': 'Baskisk',
    'nb.fa': 'Persisk',
    'nb.ff': 'Fula',
    'nb.fi': 'Finsk',
    'nb.fj': 'Fijiansk',
    'nb.fo': 'Færøysk',
    'nb.fr': 'Fransk',
    'nb.fy': 'Vestfrisisk',
    'nb.ga': 'Irsk',
    'nb.gd': 'Skotsk Gælisk',
    'nb.gl': 'Galisisk',
    'nb.gn': 'Guarani',
    'nb.gu': 'Gujarati',
    'nb.gv': 'Manx',
    'nb.ha': 'Hausa',
    'nb.he': 'Hebraisk',
    'nb.iw': 'Hebraisk',
    'nb.hi': 'Hindi',
    'nb.ho': 'Hiri Motu',
    'nb.hr': 'Kroatisk',
    'nb.ht': 'Haitisk',
    'nb.hu': 'Ungarsk',
    'nb.hy': 'Armensk',
    'nb.hz': 'Herero',
    'nb.ia': 'Interlingua',
    'nb.in': 'Indonesisk',
    'nb.ie': 'Interlingue',
    'nb.ig': 'Igbo',
    'nb.ii': 'Nuosu',
    'nb.ik': 'Inupiaq',
    'nb.io': 'Jeg Gjør',
    'nb.is': 'Islandsk',
    'nb.it': 'Italiensk',
    'nb.iu': 'Inuktitut',
    'nb.ja': 'Japansk',
    'nb.jv': 'Javanesisk',
    'nb.ka': 'Georgisk',
    'nb.kg': 'Kongo',
    'nb.ki': 'Kikuyu',
    'nb.kj': 'Kwanyama',
    'nb.kk': 'Kasakhisk',
    'nb.kl': 'Kalaallisut',
    'nb.km': 'Khmer',
    'nb.kn': 'Kannada',
    'nb.ko': 'Koreansk',
    'nb.kr': 'Kanuri',
    'nb.ks': 'Kashmiri',
    'nb.ku': 'Kurdisk',
    'nb.kv': 'Komi',
    'nb.kw': 'Cornish',
    'nb.ky': 'Kirgisisk',
    'nb.la': 'Latin',
    'nb.lb': 'Luxemburgsk',
    'nb.lg': 'Ganda',
    'nb.li': 'Limburgsk',
    'nb.ln': 'Lingala',
    'nb.lo': 'Lao',
    'nb.lt': 'Litauisk',
    'nb.lu': 'Luba-katanga',
    'nb.lv': 'Latvisk',
    'nb.mg': 'Madagassisk',
    'nb.mh': 'Marshallsk',
    'nb.mi': 'Maori',
    'nb.mk': 'Makedonsk',
    'nb.ml': 'Malayalam',
    'nb.mn': 'Mongolsk',
    'nb.mr': 'Marathi',
    'nb.ms': 'Malayisk',
    'nb.mt': 'Maltesisk',
    'nb.my': 'Burmesisk',
    'nb.na': 'Nauru',
    'nb.nb': 'Norsk Bokmål',
    'nb.nd': 'Nord -ndebele',
    'nb.ne': 'Nepali',
    'nb.ng': 'Ndonga',
    'nb.nl': 'Nederlandsk',
    'nb.nn': 'Norsk Nynorsk',
    'nb.no': 'Norsk',
    'nb.nr': 'Sør -ndebele',
    'nb.nv': 'Navajo, Navaho',
    'nb.ny': 'Chichewa',
    'nb.oc': 'Oksitansk',
    'nb.oj': 'Ojibwe, Ojibwa',
    'nb.om': 'Oromo',
    'nb.or': 'Oriya',
    'nb.os': 'Ossetisk, Ossetisk',
    'nb.pa': 'Panjabi, Punjabi',
    'nb.pi': 'Pali',
    'nb.pl': 'Pusse',
    'nb.ps': 'Pashto, Pushto',
    'nb.pt': 'Portugisisk',
    'nb.qu': 'Quechua',
    'nb.rm': 'Romansk',
    'nb.rn': 'Kirundi',
    'nb.ro': 'Rumensk',
    'nb.ru': 'Russisk',
    'nb.rw': 'Kinyarwanda',
    'nb.sa': 'Sanskrit',
    'nb.sc': 'Sardinsk',
    'nb.sd': 'Sindhi',
    'nb.se': 'Nordsamisk',
    'nb.sg': 'Sango',
    'nb.si': 'Sinhala',
    'nb.sk': 'Slovakisk',
    'nb.sl': 'Slovensk',
    'nb.sm': 'Samoansk',
    'nb.sn': 'Shona',
    'nb.so': 'Somalisk',
    'nb.sq': 'Albansk',
    'nb.sr': 'Serbisk',
    'nb.ss': 'Swati',
    'nb.st': 'Sør -sotho',
    'nb.su': 'Sundanesisk',
    'nb.sv': 'Svensk',
    'nb.sw': 'Swahili',
    'nb.ta': 'Tamil',
    'nb.te': 'Telugu',
    'nb.tg': 'Tadsjikisk',
    'nb.th': 'Thai',
    'nb.ti': 'Tigrinya',
    'nb.tk': 'Turkmenere',
    'nb.tl': 'Tagalog',
    'nb.tn': 'Tswana',
    'nb.to': 'Tonga',
    'nb.tr': 'Tyrkisk',
    'nb.ts': 'Tsonga',
    'nb.tt': 'Tatarisk',
    'nb.tw': 'Twi',
    'nb.ty': 'Tahitisk',
    'nb.ug': 'Uigurer',
    'nb.uk': 'Ukrainsk',
    'nb.ur': 'Urdu',
    'nb.uz': 'Usbekisk',
    'nb.ve': 'Venda',
    'nb.vi': 'Vietnamesisk',
    'nb.vo': 'Volapãk',
    'nb.wa': 'Vallonske',
    'nb.wo': 'Wolof',
    'nb.xh': 'Xhosa',
    'nb.yi': 'Jiddisch',
    'nb.yo': 'Yoruba',
    'nb.za': 'Zhuang',
    'nb.zh': 'Kinesisk',
    'nb.zu': 'Zulu',
    'nb.en-US': 'Engelsk',
    'nb.en-GB': 'Engelsk',
    'nb.fr-FR': 'Fransk',
    'nb.fr-CA': 'Fransk',
    // Portuguese
    'pt.aa': 'Afar',
    'pt.ab': 'Abkhaz',
    'pt.ae': 'Avestan',
    'pt.af': 'Afrikaans',
    'pt.ak': 'Akan',
    'pt.am': 'Amárico',
    'pt.an': 'Aragonês',
    'pt.ar': 'Árabe',
    'pt.as': 'Assamês',
    'pt.av': 'Avaric',
    'pt.ay': 'Aimará',
    'pt.az': 'Sul Do Azerbaijão',
    'pt.ba': 'Bashkir',
    'pt.be': 'Bielo-russo',
    'pt.bg': 'Búlgaro',
    'pt.bh': 'Bihari',
    'pt.bi': 'Bislama',
    'pt.bm': 'Bambara',
    'pt.bn': 'Bengali',
    'pt.bo': 'Padrão Tibetano',
    'pt.br': 'Bretão',
    'pt.bs': 'Bósnio',
    'pt.ca': 'Catalão',
    'pt.ce': 'Checheno',
    'pt.ch': 'Chamorro',
    'pt.co': 'Corso',
    'pt.cr': 'Cree',
    'pt.cs': 'Tcheco',
    'pt.cu': 'Old Church Slavonic',
    'pt.cv': 'Chuvash',
    'pt.cy': 'Galês',
    'pt.da': 'Dinamarquês',
    'pt.de': 'Alemão',
    'pt.dv': 'Divehi',
    'pt.dz': 'Dzongkha',
    'pt.ee': 'Ovelha',
    'pt.el': 'Grego, Moderno',
    'pt.en': 'Inglês',
    'pt.eo': 'Esperanto',
    'pt.es': 'Espanhol',
    'pt.et': 'Estoniano',
    'pt.eu': 'Basco',
    'pt.fa': 'Persa',
    'pt.ff': 'Fula',
    'pt.fi': 'Finlandês',
    'pt.fj': 'De Fiji',
    'pt.fo': 'Faroense',
    'pt.fr': 'Francês',
    'pt.fy': 'Frísio Ocidental',
    'pt.ga': 'Irlandês',
    'pt.gd': 'Gaélico Escocês',
    'pt.gl': 'Galego',
    'pt.gn': 'Guarani',
    'pt.gu': 'Guzerate',
    'pt.gv': 'Manx',
    'pt.ha': 'Hausa',
    'pt.he': 'Hebraico',
    'pt.iw': 'Hebraico',
    'pt.hi': 'Hindi',
    'pt.ho': 'Hiri Motu',
    'pt.hr': 'Croata',
    'pt.ht': 'Haitiano',
    'pt.hu': 'Húngaro',
    'pt.hy': 'Armênio',
    'pt.hz': 'Herero',
    'pt.ia': 'Interlíngua',
    'pt.in': 'Indonésio',
    'pt.ie': 'Interlingue',
    'pt.ig': 'Igbo',
    'pt.ii': 'Nuosu',
    'pt.ik': 'Inupiaq',
    'pt.io': 'Eu Faço',
    'pt.is': 'Islandês',
    'pt.it': 'Italiano',
    'pt.iu': 'Inuktitut',
    'pt.ja': 'Japonês',
    'pt.jv': 'Javanês',
    'pt.ka': 'Georgiano',
    'pt.kg': 'Kongo',
    'pt.ki': 'Kikuyu',
    'pt.kj': 'Kwanyama',
    'pt.kk': 'Cazaque',
    'pt.kl': 'Kalaallisut',
    'pt.km': 'Khmer',
    'pt.kn': 'Canarim',
    'pt.ko': 'Coreano',
    'pt.kr': 'Kanuri',
    'pt.ks': 'Caxemira',
    'pt.ku': 'Curdo',
    'pt.kv': 'Komi',
    'pt.kw': 'Cornish',
    'pt.ky': 'Quirguiz',
    'pt.la': 'Latina',
    'pt.lb': 'Luxemburguês',
    'pt.lg': 'Ganda',
    'pt.li': 'Limburguês',
    'pt.ln': 'Lingala',
    'pt.lo': 'Lao',
    'pt.lt': 'Lituano',
    'pt.lu': 'Luba-katanga',
    'pt.lv': 'Letão',
    'pt.mg': 'Malgaxe',
    'pt.mh': 'Marshalês',
    'pt.mi': 'Maori',
    'pt.mk': 'Macedônio',
    'pt.ml': 'Malaiala',
    'pt.mn': 'Mongol',
    'pt.mr': 'Marati',
    'pt.ms': 'Malaio',
    'pt.mt': 'Maltês',
    'pt.my': 'Birmanês',
    'pt.na': 'Nauru',
    'pt.nb': 'Bokmål Norueguês',
    'pt.nd': 'Ndebele Do Norte',
    'pt.ne': 'Nepalês',
    'pt.ng': 'Ndonga',
    'pt.nl': 'Holandês',
    'pt.nn': 'Nynorsk Norueguês',
    'pt.no': 'Norueguês',
    'pt.nr': 'Ndebele Do Sul',
    'pt.nv': 'Navajo, Navaho',
    'pt.ny': 'Chichewa',
    'pt.oc': 'Occitano',
    'pt.oj': 'Ojibwe, Ojibwa',
    'pt.om': 'Oromo',
    'pt.or': 'Oriya',
    'pt.os': 'Ossétia, Ossética',
    'pt.pa': 'Panjabi, Punjabi',
    'pt.pi': 'Pali',
    'pt.pl': 'Polonês',
    'pt.ps': 'Pashto, Pachto',
    'pt.pt': 'Português',
    'pt.qu': 'Quechua',
    'pt.rm': 'Romanche',
    'pt.rn': 'Kirundi',
    'pt.ro': 'Romena',
    'pt.ru': 'Russo',
    'pt.rw': 'Kinyarwanda',
    'pt.sa': 'Sânscrito',
    'pt.sc': 'Da Sardenha',
    'pt.sd': 'Sindi',
    'pt.se': 'Sami Do Norte',
    'pt.sg': 'Sango',
    'pt.si': 'Cingalês',
    'pt.sk': 'Eslovaco',
    'pt.sl': 'Esloveno',
    'pt.sm': 'Samoano',
    'pt.sn': 'Shona',
    'pt.so': 'Somali',
    'pt.sq': 'Albanês',
    'pt.sr': 'Sérvio',
    'pt.ss': 'Swati',
    'pt.st': 'Sotho Do Sul',
    'pt.su': 'Sudanês',
    'pt.sv': 'Sueco',
    'pt.sw': 'Suaíli',
    'pt.ta': 'Tâmil',
    'pt.te': 'Telugu',
    'pt.tg': 'Tadjique',
    'pt.th': 'Tailandês',
    'pt.ti': 'Tigrinya',
    'pt.tk': 'Turcomano',
    'pt.tl': 'Tagalo',
    'pt.tn': 'Tswana',
    'pt.to': 'Tonga',
    'pt.tr': 'Turco',
    'pt.ts': 'Tsonga',
    'pt.tt': 'Tártaro',
    'pt.tw': 'Twi',
    'pt.ty': 'Taitiano',
    'pt.ug': 'Uigur',
    'pt.uk': 'Ucraniano',
    'pt.ur': 'Urdu',
    'pt.uz': 'Uzbeque',
    'pt.ve': 'Venda',
    'pt.vi': 'Vietnamita',
    'pt.vo': 'Volapík',
    'pt.wa': 'Valão',
    'pt.wo': 'Wolof',
    'pt.xh': 'Xhosa',
    'pt.yi': 'Iídiche',
    'pt.yo': 'Ioruba',
    'pt.za': 'Zhuang',
    'pt.zh': 'Chinês',
    'pt.zu': 'Zulu',
    'pt.en-US': 'Inglês',
    'pt.en-GB': 'Inglês',
    'pt.fr-FR': 'Francês',
    'pt.fr-CA': 'Francês',
    // Spanish
    'es.aa': 'Afar',
    'es.ab': 'Abjasio',
    'es.ae': 'Avestan',
    'es.af': 'Africaans',
    'es.ak': 'Akan',
    'es.am': 'Amárico',
    'es.an': 'Aragonés',
    'es.ar': 'Arábica',
    'es.as': 'Asamés',
    'es.av': 'Avarico',
    'es.ay': 'Aimara',
    'es.az': 'Azerbaiyano Del Sur',
    'es.ba': 'Bashkir',
    'es.be': 'Bielorruso',
    'es.bg': 'Búlgaro',
    'es.bh': 'Bihari',
    'es.bi': 'Bislama',
    'es.bm': 'Bambara',
    'es.bn': 'Bengalí',
    'es.bo': 'Estándar Tibetano',
    'es.br': 'Bretón',
    'es.bs': 'Bosnio',
    'es.ca': 'Catalán',
    'es.ce': 'Checheno',
    'es.ch': 'Chamorro',
    'es.co': 'Corso',
    'es.cr': 'Cree',
    'es.cs': 'Checo',
    'es.cu': 'Antiguo Eslavo Eclesiástico',
    'es.cv': 'Chuvash',
    'es.cy': 'Galés',
    'es.da': 'Danés',
    'es.de': 'Alemán',
    'es.dv': 'Divehi',
    'es.dz': 'Dzongkha',
    'es.ee': 'Oveja',
    'es.el': 'Griego, Moderno',
    'es.en': 'Inglés',
    'es.eo': 'Esperanto',
    'es.es': 'Español',
    'es.et': 'Estonio',
    'es.eu': 'Vasco',
    'es.fa': 'Persa',
    'es.ff': 'Fula',
    'es.fi': 'Finlandés',
    'es.fj': 'Fiyiano',
    'es.fo': 'Feroés',
    'es.fr': 'Francés',
    'es.fy': 'Frisón Occidental',
    'es.ga': 'Irlandesa',
    'es.gd': 'Gaélico Escocés',
    'es.gl': 'Gallego',
    'es.gn': 'Guaraní',
    'es.gu': 'Gujarati',
    'es.gv': 'De La Isla De Man',
    'es.ha': 'Hausa',
    'es.he': 'Hebreo',
    'es.iw': 'Hebreo',
    'es.hi': 'Hindi',
    'es.ho': 'Hiri Motu',
    'es.hr': 'Croata',
    'es.ht': 'Haitiano',
    'es.hu': 'Húngaro',
    'es.hy': 'Armenio',
    'es.hz': 'Herero',
    'es.ia': 'Interlingua',
    'es.in': 'Indonesio',
    'es.ie': 'Interlingual',
    'es.ig': 'Igbo',
    'es.ii': 'Nuosu',
    'es.ik': 'Inupiaq',
    'es.io': 'Hago',
    'es.is': 'Islandés',
    'es.it': 'Italiano',
    'es.iu': 'Inuktitut',
    'es.ja': 'Japonés',
    'es.jv': 'Javanés',
    'es.ka': 'Georgiano',
    'es.kg': 'Kongo',
    'es.ki': 'Kikuyu',
    'es.kj': 'Kwanyama',
    'es.kk': 'Kazajo',
    'es.kl': 'Kalaallisut',
    'es.km': 'Jemer',
    'es.kn': 'Canarés',
    'es.ko': 'Coreano',
    'es.kr': 'Kanuri',
    'es.ks': 'Cachemira',
    'es.ku': 'Kurdo',
    'es.kv': 'Komi',
    'es.kw': 'De Cornualles',
    'es.ky': 'Kirguís',
    'es.la': 'Latín',
    'es.lb': 'Luxemburgués',
    'es.lg': 'Ganda',
    'es.li': 'Limburgués',
    'es.ln': 'Lingala',
    'es.lo': 'Lao',
    'es.lt': 'Lituano',
    'es.lu': 'Luba-katanga',
    'es.lv': 'Letón',
    'es.mg': 'Madagascarí',
    'es.mh': 'Marshalés',
    'es.mi': 'Maorí',
    'es.mk': 'Macedónio',
    'es.ml': 'Malayalam',
    'es.mn': 'Mongol',
    'es.mr': 'Marathi',
    'es.ms': 'Malayo',
    'es.mt': 'Maltés',
    'es.my': 'Birmano',
    'es.na': 'Nauru',
    'es.nb': 'Noruego Bokmål',
    'es.nd': 'North Ndebele',
    'es.ne': 'Nepalí',
    'es.ng': 'Ndonga',
    'es.nl': 'Holandés',
    'es.nn': 'Noruego Nynorsk',
    'es.no': 'Noruego',
    'es.nr': 'Ndebele Del Sur',
    'es.nv': 'Navajo, Navajo',
    'es.ny': 'Chichewa',
    'es.oc': 'Occitano',
    'es.oj': 'Ojibwe, Ojibwa',
    'es.om': 'Oromo',
    'es.or': 'Oriya',
    'es.os': 'Osetio, Osetico',
    'es.pa': 'Panjabi, Punjabi',
    'es.pi': 'Pali',
    'es.pl': 'Polaco',
    'es.ps': 'Pashto, Pushto',
    'es.pt': 'Portugués',
    'es.qu': 'Quechua',
    'es.rm': 'Romanche',
    'es.rn': 'Kirundi',
    'es.ro': 'Rumano',
    'es.ru': 'Ruso',
    'es.rw': 'Kinyarwanda',
    'es.sa': 'Sánscrito',
    'es.sc': 'Sardo',
    'es.sd': 'Sindhi',
    'es.se': 'Sami Del Norte',
    'es.sg': 'Sango',
    'es.si': 'Cingalés',
    'es.sk': 'Eslovaco',
    'es.sl': 'Esloveno',
    'es.sm': 'Samoano',
    'es.sn': 'Shona',
    'es.so': 'Somalí',
    'es.sq': 'Albanés',
    'es.sr': 'Serbio',
    'es.ss': 'Swati',
    'es.st': 'Sur De Sotho',
    'es.su': 'Sundanés',
    'es.sv': 'Sueco',
    'es.sw': 'Swahili',
    'es.ta': 'Tamil',
    'es.te': 'Telugu',
    'es.tg': 'Tayiko',
    'es.th': 'Tailandés',
    'es.ti': 'Tigrinya',
    'es.tk': 'Turcomano',
    'es.tl': 'Tagalo',
    'es.tn': 'Tswana',
    'es.to': 'Tonga',
    'es.tr': 'Turco',
    'es.ts': 'Tsonga',
    'es.tt': 'Tártaro',
    'es.tw': 'Twi',
    'es.ty': 'Tahitiano',
    'es.ug': 'Uigur',
    'es.uk': 'Ucranio',
    'es.ur': 'Urdu',
    'es.uz': 'Uzbeko',
    'es.ve': 'Venda',
    'es.vi': 'Vietnamita',
    'es.vo': 'Volapãk',
    'es.wa': 'Valonia',
    'es.wo': 'Wolof',
    'es.xh': 'Xhosa',
    'es.yi': 'Yídish',
    'es.yo': 'Yoruba',
    'es.za': 'Zhuang',
    'es.zh': 'Chino',
    'es.zu': 'Zulú',
    'es.en-US': 'Inglés',
    'es.en-GB': 'Inglés',
    'es.fr-FR': 'Francés',
    'es.fr-CA': 'Francés',
    // Swedish
    'sv.aa': 'Afar',
    'sv.ab': 'Abkhaz',
    'sv.ae': 'Avestan',
    'sv.af': 'Afrikaans',
    'sv.ak': 'Akan',
    'sv.am': 'Amhariska',
    'sv.an': 'Aragonese',
    'sv.ar': 'Arabiska',
    'sv.as': 'Assamiska',
    'sv.av': 'Avaric',
    'sv.ay': 'Aymara',
    'sv.az': 'Södra Azerbajdzjan',
    'sv.ba': 'Bashkir',
    'sv.be': 'Vitryska',
    'sv.bg': 'Bulgariska',
    'sv.bh': 'Bihari',
    'sv.bi': 'Bislama',
    'sv.bm': 'Bambara',
    'sv.bn': 'Bengali',
    'sv.bo': 'Tibetansk Standard',
    'sv.br': 'Breton',
    'sv.bs': 'Bosniska',
    'sv.ca': 'Katalanska',
    'sv.ce': 'Tjetjenska',
    'sv.ch': 'Chamorro',
    'sv.co': 'Korsikanska',
    'sv.cr': 'Cree',
    'sv.cs': 'Tjeckiska',
    'sv.cu': 'Gamla Kyrkliga Slaviska',
    'sv.cv': 'Chuvash',
    'sv.cy': 'Walesiska',
    'sv.da': 'Danska',
    'sv.de': 'Tysk',
    'sv.dv': 'Divehi',
    'sv.dz': 'Dzongkha',
    'sv.ee': 'Tacka',
    'sv.el': 'Grekiska, Moderna',
    'sv.en': 'Engelsk',
    'sv.eo': 'Esperanto',
    'sv.es': 'Spanska',
    'sv.et': 'Estniska',
    'sv.eu': 'Baskiska',
    'sv.fa': 'Persiska',
    'sv.ff': 'Fula',
    'sv.fi': 'Finska',
    'sv.fj': 'Fijianska',
    'sv.fo': 'Färöiska',
    'sv.fr': 'Franska',
    'sv.fy': 'Västerländska Frisiska',
    'sv.ga': 'Irländska',
    'sv.gd': 'Skotsk Gæliska',
    'sv.gl': 'Galiciska',
    'sv.gn': 'Guarani',
    'sv.gu': 'Gujarati',
    'sv.gv': 'Manx',
    'sv.ha': 'Hausa',
    'sv.he': 'Hebreiska',
    'sv.iw': 'Hebreiska',
    'sv.hi': 'Hindi',
    'sv.ho': 'Hiri Motu',
    'sv.hr': 'Kroatisk',
    'sv.ht': 'Haitiska',
    'sv.hu': 'Ungerska',
    'sv.hy': 'Armeniska',
    'sv.hz': 'Herero',
    'sv.ia': 'Interlingua',
    'sv.in': 'Indonesiska',
    'sv.ie': 'Interlingue',
    'sv.ig': 'Igbo',
    'sv.ii': 'Nuosu',
    'sv.ik': 'Inupiaq',
    'sv.io': 'Jag Gör',
    'sv.is': 'Isländska',
    'sv.it': 'Italienska',
    'sv.iu': 'Inuktitut',
    'sv.ja': 'Japanska',
    'sv.jv': 'Javanesiska',
    'sv.ka': 'Georgiska',
    'sv.kg': 'Kongo',
    'sv.ki': 'Kikuyu',
    'sv.kj': 'Kwanyama',
    'sv.kk': 'Kazakiska',
    'sv.kl': 'Kalaallisut',
    'sv.km': 'Khmer',
    'sv.kn': 'Kannada',
    'sv.ko': 'Koreanska',
    'sv.kr': 'Kanuri',
    'sv.ks': 'Kashmiri',
    'sv.ku': 'Kurdiska',
    'sv.kv': 'Komi',
    'sv.kw': 'Cornish',
    'sv.ky': 'Kirgisiska',
    'sv.la': 'Latin',
    'sv.lb': 'Luxemburgska',
    'sv.lg': 'Ganda',
    'sv.li': 'Limburgiska',
    'sv.ln': 'Lingala',
    'sv.lo': 'Lao',
    'sv.lt': 'Litauiska',
    'sv.lu': 'Luba-katanga',
    'sv.lv': 'Lettiska',
    'sv.mg': 'Madagaskisk',
    'sv.mh': 'Marshallesiska',
    'sv.mi': 'Maori',
    'sv.mk': 'Makedonska',
    'sv.ml': 'Malayalam',
    'sv.mn': 'Mongoliska',
    'sv.mr': 'Marathi',
    'sv.ms': 'Malaysiska',
    'sv.mt': 'Maltesiska',
    'sv.my': 'Burmesiska',
    'sv.na': 'Nauru',
    'sv.nb': 'Norska Bokmål',
    'sv.nd': 'Norra Ndebele',
    'sv.ne': 'Nepali',
    'sv.ng': 'Ndonga',
    'sv.nl': 'Holländska',
    'sv.nn': 'Norska Nynorsk',
    'sv.no': 'Norska',
    'sv.nr': 'Södra Ndebele',
    'sv.nv': 'Navajo, Navaho',
    'sv.ny': 'Chichewa',
    'sv.oc': 'Occitan',
    'sv.oj': 'Ojibwe, Ojibwa',
    'sv.om': 'Oromo',
    'sv.or': 'Oriya',
    'sv.os': 'Ossetiska, Osetiska',
    'sv.pa': 'Panjabi, Punjabi',
    'sv.pi': 'Pali',
    'sv.pl': 'Putsa',
    'sv.ps': 'Pashto, Pushto',
    'sv.pt': 'Portugisiska',
    'sv.qu': 'Quechua',
    'sv.rm': 'Romersk',
    'sv.rn': 'Kirundi',
    'sv.ro': 'Rumänska',
    'sv.ru': 'Ryska',
    'sv.rw': 'Kinyarwanda',
    'sv.sa': 'Sanskrit',
    'sv.sc': 'Sardinsk',
    'sv.sd': 'Sindhi',
    'sv.se': 'Nordsamiska',
    'sv.sg': 'Sango',
    'sv.si': 'Sinhala',
    'sv.sk': 'Slovakiska',
    'sv.sl': 'Slovenska',
    'sv.sm': 'Samoanska',
    'sv.sn': 'Shona',
    'sv.so': 'Somaliska',
    'sv.sq': 'Albanska',
    'sv.sr': 'Serbiska',
    'sv.ss': 'Swati',
    'sv.st': 'Södra Sotho',
    'sv.su': 'Sundaneser',
    'sv.sv': 'Svenska',
    'sv.sw': 'Swahili',
    'sv.ta': 'Tamil',
    'sv.te': 'Telugu',
    'sv.tg': 'Tadzjikiska',
    'sv.th': 'Thai',
    'sv.ti': 'Tigrinya',
    'sv.tk': 'Turkmener',
    'sv.tl': 'Tagalog',
    'sv.tn': 'Tswana',
    'sv.to': 'Tonga',
    'sv.tr': 'Turkiska',
    'sv.ts': 'Tsonga',
    'sv.tt': 'Tatariska',
    'sv.tw': 'Twi',
    'sv.ty': 'Tahitiska',
    'sv.ug': 'Uyghur',
    'sv.uk': 'Ukrainska',
    'sv.ur': 'Urdu',
    'sv.uz': 'Uzbekiska',
    'sv.ve': 'Venda',
    'sv.vi': 'Vietnamesiska',
    'sv.vo': 'Volapãk',
    'sv.wa': 'Vallonska',
    'sv.wo': 'Wolof',
    'sv.xh': 'Xhosa',
    'sv.yi': 'Jiddisch',
    'sv.yo': 'Yoruba',
    'sv.za': 'Zhuang',
    'sv.zh': 'Kinesiska',
    'sv.zu': 'Zulu',
    'sv.en-US': 'Engelsk',
    'sv.en-GB': 'Engelsk',
    'sv.fr-FR': 'Franska',
    'sv.fr-CA': 'Franska',
};
